/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 59);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(30)('wks');
var uid = __webpack_require__(21);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(41);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var ctx = __webpack_require__(17);
var hide = __webpack_require__(7);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(3);
var createDesc = __webpack_require__(20);
module.exports = __webpack_require__(5) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(93);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ua */
/* unused harmony export locationOriginRegex */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isOpera */
/* unused harmony export isChrome */
/* unused harmony export isIOS */
/* unused harmony export isAndroid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return truthy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return falsy; });
/* unused harmony export existy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isDefined; });
/* unused harmony export isRc */
/* unused harmony export isInteger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isBoolean; });
/* unused harmony export isObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isFunction; });
/* unused harmony export isRegExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return not; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isNotDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return parseInt10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return parseStrIntToInt; });
/* unused harmony export removeElementInArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return anyOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return notSingleEle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return each; });
/* unused harmony export getFileExtension */
/* unused harmony export getFirstObjectHasProperty */
/* unused harmony export getObjectHasProperty */
/* unused harmony export overlappedConditionSortByProperty */
/* unused harmony export getPositionFromTranslateStr */
/* unused harmony export isIndexInLoop */
/* unused harmony export getLoopedLastIndex */
/* unused harmony export getReverseLoopedFirstIndex */
/* unused harmony export getResolution */
/* unused harmony export isPhoneResolution */
/* unused harmony export isTabletResolution */
/* unused harmony export isMobileResolution */
/* unused harmony export numberWithCommas */
/* unused harmony export getUriParams */
/* unused harmony export getUriCombinedParams */
/* unused harmony export getHashParams */
/* unused harmony export getHashCombinedParams */
/* unused harmony export getObjForPagination */
/* unused harmony export getDivideIntStrByThousandUnit */
/* unused harmony export getMarketPriceStr */
/* unused harmony export getEmphasizedStrByQuery */
/* unused harmony export getSeparatedDateStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return namespace; });
/* unused harmony export template */
/* unused harmony export getUrlAddCategoryIdByArticle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getChangedStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPlusElixirPointByLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isLevelCanConsumeElixirStat; });
/* unused harmony export isLevelGetElixirPoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStatMaxByLevel; });
/* unused harmony export isWarrior */
/* unused harmony export getClassName */
/* unused harmony export removeEquipInEquips */
/* unused harmony export isPetNecklace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(33);

/*
 * common utils
 */



var ua = window.navigator.userAgent;

var locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

var isIE = function () {
  return (/msie/i.test(ua) || /trident/i.test(ua)
  );
}();

var isEdge = function isEdge(userAgent) {
  return (/Gecko/i.test(userAgent) && /Edge/i.test(userAgent)
  );
};

var isOpera = function isOpera(userAgent) {
  return (/Opera/i.test(userAgent) || /OPR\//i.test(userAgent)
  );
};

var isChrome = function isChrome(userAgent) {
  return !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent);
};

var isIOS = function isIOS(userAgent) {
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroid = function isAndroid(userAgent) {
  return (/android/i.test(userAgent)
  );
};

var truthy = function truthy(object) {
  return !!object;
};

var falsy = function falsy(object) {
  return !!!object;
};

var existy = function existy(obj) {
  return obj != null;
};

var isDefined = function isDefined(obj) {
  var flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

var isRc = function () {
  return isDefined(/^rc-/.exec(location.hostname));
}();

var isInteger = function isInteger(obj) {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return isFinite(obj) && Math.floor(obj) === obj;
};

var isString = function isString(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === String;
};

var isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Number;
};

var isBoolean = function isBoolean(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Boolean;
};

var isObject = function isObject(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Function;
};

var isRegExp = function isRegExp(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === RegExp;
};

var not = function not(func) {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return function (object) {
    return !func(object);
  };
};

var isNotDefined = not(isDefined);

var parseInt10 = function parseInt10(number) {
  return parseInt(number, 10);
};

var parseStrIntToInt = function parseStrIntToInt(strIntOrInt) {
  var val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof val === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

var removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
      index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

var allOf = function allOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return val === true;
  });
};

var anyOf = function anyOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return val === true;
  });
};

var getDefined = function getDefined(val, defaultVal) {
  return isDefined(val) ? val : defaultVal;
};

var notSingleEle = not(function ($ele) {
  return $ele.length === 1;
});

var each = function each(dataCanLoop, func, context) {
  var _context = existy(context) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  var result = false;
  for (var i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

var getFileExtension = function getFileExtension(fileName) {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
      extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

var getFirstObjectHasProperty = function getFirstObjectHasProperty(arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  var obj = void 0,
      result = null;
  for (var i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

var getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  var obj = void 0,
      result = null;

  each(arrayHasObjects, function (obj) {
    if (obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};

var overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  var datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  var conditionIndex = _conditionIndex >= 0 ? _conditionIndex : 0,
      condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    var prevProperty = condition.property,
        nextConditionIndex = conditionIndex + 1,
        nextCondition = _conditions[nextConditionIndex];

    var memoObj = {},
        memoArr = [],
        arr = [];

    var obj = void 0,
        prop = void 0;
    for (var i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (var j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    var resultArr = memoArr.reduce(function (acc, curVal, curIndex, array) {
      return acc.concat(curVal);
    });

    return resultArr;
  }

  return datas;
};

var getPositionFromTranslateStr = function getPositionFromTranslateStr(str) {
  var obj = { x: 0, y: 0 };
  if (!isDefined(str)) return obj;

  var values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

var isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = index + 1 > totalLength ? 1 : index + 1;
  }

  return false;
};

var getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

var getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  var index = lastIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index = index - 1 < 1 ? totalLength : index - 1;
  }

  return index;
};

var getResolution = function getResolution() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tablet: 640, pc: 960, max: 1260 };
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';
  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';
  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';
  } else {
    resolution = 'phone';
  }

  return resolution;
};

var isPhoneResolution = function isPhoneResolution(resolution) {
  return resolution === 'phone';
};

var isTabletResolution = function isTabletResolution(resolution) {
  return resolution === 'tablet';
};

var isMobileResolution = function isMobileResolution(resolution) {
  return resolution === 'phone' || resolution === 'tablet';
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getUriParams = function getUriParams(uri) {
  if (uri.length < 1) return null;
  var str = uri.split('#')[0];

  var tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

var getUriCombinedParams = function getUriCombinedParams(uri, params) {
  if (!uri) return '';
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
      uri = tmpArr[0],
      hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;
  return uri;
};

var getHashParams = function getHashParams(hashStr) {
  var str = hashStr;
  if (str.length < 1) return null;

  var tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

var getHashCombinedParams = function getHashCombinedParams(uri, params) {
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = uri.indexOf('#') >= 0 ? uri + str : uri + '#' + str.substr(1);
  return uri;
};

var getObjForPagination = function getObjForPagination(totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  var args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  var totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  var paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
      prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
      firstPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum + 1,
      lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
      nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

var getDivideIntStrByThousandUnit = function getDivideIntStrByThousandUnit(intStr_) {
  if (not(isDefined)(intStr_)) return ['0'];

  var DIVIDE_UNIT = 4;

  var intStr = String(parseStrIntToInt(intStr_)),
      intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  var lastIndex = 0,
      unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

var getMarketPriceStr = function getMarketPriceStr(str) {
  var UNIT_PRICE = ['', '만', '억'];

  var val = isDefined(str) ? str : '0',
      unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  var priceStr = '',
      unitVal = 0;
  for (var i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = numberWithCommas(unitVal) + UNIT_PRICE[i] + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

var getEmphasizedStrByQuery = function getEmphasizedStrByQuery(str, query) {
  return (str || '').split(query).join('<strong>' + query + '</strong>');
};

var getSeparatedDateStr = function getSeparatedDateStr(moment, dateStr) {
  var DAYS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    'Sunday': '일',
    'Monday': '월',
    'Tuesday': '화',
    'Wednesday': '수',
    'Thursday': '목',
    'Friday': '금',
    'Saturday': '토'
  };

  var val = '';

  var MIN_TO_SEC = 60,
      HOUR_TO_SEC = 3600,
      DAY_TO_SEC = 86400;

  var now = new Date(),
      past = new Date(dateStr),
      diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = diffSeconds + '\uCD08 \uC804';
      } else {
        var diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = diffMinutes + '\uBD84 \uC804';
      }
    } else {
      var diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = diffHours + '\uC2DC\uAC04 \uC804';
    }
  } else {
    var date = moment(dateStr),
        day = DAYS[date.format('dddd')] || '';

    val = date.format('YYYY-MM-DD');
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

var namespace = function namespace(_namespace, parent) {
  if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  var ns = parent || window;

  if (_namespace) {
    var parts = _namespace.split('.');

    for (var i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

var template = function template(strings) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return function () {
    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }

    var dict = values[values.length - 1] || {};

    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  };
};

// board - server list
var getUrlAddCategoryIdByArticle = function getUrlAddCategoryIdByArticle(_url, _article, _serverNameMap) {
  var url = _url;

  if (url !== '#') {
    var path = url.split('?')[0],
        uriParams = getUriParams(url);

    var categoryId = isObject(_article.category) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, { categoryId: categoryId }));
  }

  return url;
};

// character setting - stat, equip simulator
var getChangedStats = function getChangedStats(originalStatObj, newStatObj) {
  var changedStats = {};

  var stat, newStat;
  for (var key in originalStatObj) {
    stat = isDefined(originalStatObj[key]) ? originalStatObj[key] : null;
    newStat = isDefined(newStatObj[key]) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  var changeStatsCount = 0;
  for (var k in changedStats) {
    changeStatsCount++;
  }return changeStatsCount > 0 ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
var getPlusElixirPointByLevel = function getPlusElixirPointByLevel(level, level_init, plusElixirPointByLevel) {
  var _plusElixirPoint = 0;
  if ((level - level_init) % 2 === 0) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, function (obj) {
    if (parseInt(obj.level) === parseInt(level)) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
var isLevelCanConsumeElixirStat = function isLevelCanConsumeElixirStat(level, perLevelPlusElixirPoint) {
  return level >= 0 ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

var isLevelGetElixirPoint = function isLevelGetElixirPoint(level, perLevelPlusElixirPoint) {
  // 2019.11
  return level % perLevelPlusElixirPoint === 0 ? true : false;
};

// STAT_MAX_BY_LEVEL 2021.
var getStatMaxByLevel = function getStatMaxByLevel(level, statMaxByLevel) {
  var _statMax = 50;
  each(statMaxByLevel, function (obj) {
    if (parseInt(obj.level) <= level) {
      _statMax = parseInt(obj.max);
    }
  });
  // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
  return _statMax;
};

var isWarrior = function isWarrior(classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
};

var getClassName = function getClassName(classId) {
  var CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사', '성기사'];

  var className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

var removeEquipInEquips = function removeEquipInEquips(equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  var clonedEquips = equips.slice();

  var equip = void 0;
  for (var i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

var isPetNecklace = function isPetNecklace(itemId) {
  return itemId === __WEBPACK_IMPORTED_MODULE_1__model_model__["b" /* PET_NECKLACE_ID */] ? true : false;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(71);
var defined = __webpack_require__(25);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(18);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(3).f;
var has = __webpack_require__(9);
var TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_util__ = __webpack_require__(12);





var singletonId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default()();
var singletonEnforcer = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default()();

var StatModel = function () {
      function StatModel(enforcer) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StatModel);

            if (enforcer !== singletonEnforcer) throw new Error('StatModel can not use construct. use getInstance method');

            /*
            update wiki list
            2019.08
            2019.11
            2021.05 CSDT-547
            2021.12 CSDT-818
             */

            var _ = this;

            _.LEVEL_INIT = 50;

            _.LEVEL_MAX = 100;
            // 엘릭서 elixir level  99 -> 100 2022.1.
            // 엘릭서 elixir level 75 -> 95  2019.08
            // 95 -> 99 (2020.09)

            _.LEVEL_USABLE_ELIXIR_POINT = 100;
            // 99 -> 100 // 2022.1.

            _.STAT_MAX_AT_LEVEL_INIT = 20;
            /* 2021.05.12 초기 스탯 최대값 셋팅 업데이트 */
            // 16 > 23
            _.STAT_MAX_AT_LEVEL_INIT_DEX_0 = 18; // 군주
            _.STAT_MAX_AT_LEVEL_INIT_INT_0 = 18;
            _.STAT_MAX_AT_LEVEL_INIT_DEX_4 = 19; // 다크엘프
            _.STAT_MAX_AT_LEVEL_INIT_INT_4 = 18;
            _.STAT_MAX_AT_LEVEL_INIT_WIS_4 = 17;

            // 2019.11  90lv 미만 캐릭터의 스탯 한도 45 -> 50
            // 2021.12  100lv 이상 50 -> 55
            _.STAT_MAX = 50;

            // when level >= 90, stat max change 50 from 45.
            // 2019.11 90lv 이상 캐릭터의 스탯 한도 50 -> 55
            _.LEVEL_CHANGE_STAT_MAX = 90;
            _.CHANGED_STAT_MAX = 55;

            // 2021.12 100레벨이 되면 60 level -> targetLevel
            _.STAT_MAX_BY_LEVEL = [{ level: 50, max: 50 }, { level: 90, max: 55 }, { level: 100, max: 60 }];

            _.STAT_LEVEL_COLORS = [{
                  level: 25,
                  class: 'em1'
            }, {
                  level: 35,
                  class: 'em2'
            }, {
                  level: 45,
                  class: 'em3'
            }];

            _.CHANGED_LEVEL_COLORS = [{
                  level: 25,
                  class: 'em1'
            }, {
                  level: 35,
                  class: 'em2'
            }, {
                  level: 50,
                  class: 'em3'
            }];

            _.PLUS_ELIXIR_POINT_BY_LEVEL = [{ level: 80, point: 2 }, { level: 90, point: 2 }, { level: 100, point: 3 }];
            _.PER_LEVEL_PLUS_ELIXIR_POINT = 2;
            // _.PER_LEVEL_PLUS_ELIXIR_POINT = 2; // 2022.01 엘렉서 50레벨부터 2레벨 당 + 1개, 80레벨일때만 +2개, 90레벨일때만 +2개, 100레벨일때만 +3개
            // _.PER_LEVEL_PLUS_ELIXIR_POINT = 3;  // 2019.11 엘릭서 50레벨부터 5레벨 당 + 1개 -> 3레벨 당 + 1개

            _.ELIXIR_POINT_INIT = 1;

            _.DEVICE_TYPE = '';

            _.DATA_INIT = null;

            _.SERVER_ID = '';

            _.CLASS_ID = '';

            // use only statSimulator page (pc, mobile)
            _.CHAR_NAME = '';

            _.USER_STAT_NUM_LIMIT = 6;
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StatModel, null, [{
            key: 'getInstance',
            value: function getInstance() {
                  if (!this[singletonId]) this[singletonId] = new StatModel(singletonEnforcer);
                  return this[singletonId];
            }
      }, {
            key: 'getDefaultStatData',
            value: function getDefaultStatData(defaultStatDataFromApi) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        page: '',
                        type: '',
                        classType: '',
                        level: 0,
                        elixirUseYN: false
                  };

                  var data = defaultStatDataFromApi,
                      sub = data.formattedSubStat,
                      attribute = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(data), Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(sub)) ? sub.attribute : null;

                  var json = {
                        'page': options.page,

                        'type': options.type,
                        'classType': options.classType,

                        // 'point' : (data) ? getDefined(data.remainStat, '0') : '-',
                        'level': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.level, options.LEVEL_INIT),

                        'HP': '-', // getDefined(data.hp, '0'),
                        'MP': '-', // getDefined(data.mp, '0'),

                        'STR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.mainStat.STR, 0),
                        'DEX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.mainStat.DEX, 0),
                        'INT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.mainStat.INT, 0),
                        'CON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.mainStat.CON, 0),
                        'WIS': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.mainStat.WIS, 0),
                        'CHA': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.mainStat.CHA, 0),

                        // STR - use formattedSubStat
                        'DAMAGE_SHORT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.damageShort, '0'),
                        'HIT_SHORT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.hitShort, '0'),
                        'FATAL_SHORT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.fatalShort, '0'),
                        'WEIGHT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.weight, '0'),

                        // DEX - use formattedSubStat
                        'DAMAGE_LONG': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.damageLong, '0'),
                        'HIT_LONG': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.hitLong, '0'),
                        'FATAL_LONG': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.fatalLong, '0'),
                        'AC': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.ac, '0'),
                        'ER': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.er, '0'),

                        // INT - use formattedSubStat
                        'DAMAGE_WIZ': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.damageWiz, '0'),
                        'HIT_WIZ': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.hitWiz, '0'),
                        'FATAL_WIZ': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.fatalWiz, '0'),
                        'MB': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.mb, '0'),
                        'MP_MINUS': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.mpMinus, '0'),

                        // WIS - use formattedSubStat
                        'LEVELUP_MP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.min, '0'),
                        'LEVELUP_MP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.max, '0'),
                        'MP_RECOVER_TIC': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverTic, '0'),
                        'MP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverLiquor, '0'),
                        'MR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.mr, '0'),

                        // CON - use formattedSubStat
                        'LEVELUP_HP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.min, '0'),
                        'LEVELUP_HP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.max, '0'),
                        'HP_RECOVER_TIC_MIN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.min, '0'),
                        'HP_RECOVER_TIC_MAX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.max, '0'),
                        'HP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverLiquor, '0'),
                        // CON WEIGHT === STR WEIGHT

                        // CHA  // 20211206
                        'CHA_HIT_SIKII': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitSkill, '0'),
                        'CHA_HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitSummon, '0'),
                        'CHA_HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitDragon, '0'),
                        'CHA_HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitFear, '0'),
                        'CHA_SKILL_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.skillTimeReduction, '0'),
                        'CHA_STATUS_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.statusTimeReduction, '0'),

                        // attribute
                        'FIRE': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.FIRE, '0') : '0',
                        'WATER': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.WATER, '0') : '0',
                        'STORM': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.STORM, '0') : '0',
                        'LAND': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.LAND, '0') : '0',
                        'HIT_SKILL': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitSkill, '0') : '0',
                        'RES_SKILL': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resSkill, '0') : '0',
                        'HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitSummon, '0') : '0',
                        'RES_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resSummon, '0') : '0',
                        'HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitDragon, '0') : '0',
                        'RES_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resDragon, '0') : '0',
                        'HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitFear, '0') : '0',
                        'RES_FEAR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resFear, '0') : '0',

                        'remainStat': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.remainStatPoint, '0'),
                        'remainTotalStat': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(data.remainStatPoint, '0'),
                        'elixirStat': 1,
                        'elixirTotalStat': 1,

                        'elixirUseYN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(options.elixirUseYN, false)
                  };

                  return json;
            }
      }, {
            key: 'getSavedStatData',
            value: function getSavedStatData(savedSimulationStat, savedUserStatInfo) {
                  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                        idex: '',
                        page: '',
                        type: ''
                  };

                  var data = savedSimulationStat,
                      user = savedUserStatInfo,
                      sub = data.formattedSubStat,
                      attribute = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(data), Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(sub)) ? sub.attribute : null;

                  var json = {
                        'idx': options.idx,
                        'page': options.page,

                        'type': options.type,
                        'classType': user.classId,
                        'targetLevel': user.targetLevel,

                        'classImageUrl': user.classImageUrl,

                        // 'point' : (data) ? getDefined(data.remainStat, '0') : '-',
                        'level': data.level,

                        'HP': data.hp,
                        'MP': data.mp,

                        'STR': data.mainStat.STR,
                        'DEX': data.mainStat.DEX,
                        'INT': data.mainStat.INT,
                        'CON': data.mainStat.CON,
                        'WIS': data.mainStat.WIS,
                        'CHA': data.mainStat.CHA,

                        // STR - use formattedSubStat
                        'DAMAGE_SHORT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.damageShort, '0'),
                        'HIT_SHORT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.hitShort, '0'),
                        'FATAL_SHORT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.fatalShort, '0'),
                        'WEIGHT': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.STR.weight, '0'),

                        // INT - use formattedSubStat
                        'DAMAGE_WIZ': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.damageWiz, '0'),
                        'HIT_WIZ': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.hitWiz, '0'),
                        'FATAL_WIZ': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.fatalWiz, '0'),
                        'MB': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.mb, '0'),
                        'MP_MINUS': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.INT.mpMinus, '0'),

                        // DEX - use formattedSubStat
                        'DAMAGE_LONG': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.damageLong, '0'),
                        'HIT_LONG': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.hitLong, '0'),
                        'FATAL_LONG': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.fatalLong, '0'),
                        'AC': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.ac, '0'),
                        'ER': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.DEX.er, '0'),

                        // WIS - use formattedSubStat
                        'LEVELUP_MP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.min, '0'),
                        'LEVELUP_MP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.max, '0'),
                        'MP_RECOVER_TIC': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverTic, '0'),
                        'MP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverLiquor, '0'),
                        'MR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.WIS.mr, '0'),

                        // CON - use formattedSubStat
                        'LEVELUP_HP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.min, '0'),
                        'LEVELUP_HP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.max, '0'),
                        'HP_RECOVER_TIC_MIN': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.min, '0'),
                        'HP_RECOVER_TIC_MAX': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.max, '0'),
                        'HP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverLiquor, '0'),
                        // CON WEIGHT === STR WEIGHT

                        // CHA  // 20211206
                        'CHA_HIT_SIKII': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitSkill, '0'),
                        'CHA_HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitSummon, '0'),
                        'CHA_HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitDragon, '0'),
                        'CHA_HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.hitFear, '0'),
                        'CHA_SKILL_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.skillTimeReduction, '0'),
                        'CHA_STATUS_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(sub.CHA.statusTimeReduction, '0'),

                        // attribute
                        'FIRE': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.FIRE, '0') : '0',
                        'WATER': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.WATER, '0') : '0',
                        'STORM': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.STORM, '0') : '0',
                        'LAND': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.LAND, '0') : '0',
                        'HIT_SKILL': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitSkill, '0') : '0',
                        'RES_SKILL': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resSkill, '0') : '0',
                        'HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitSummon, '0') : '0',
                        'RES_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resSummon, '0') : '0',
                        'HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitDragon, '0') : '0',
                        'RES_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resDragon, '0') : '0',
                        'HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.hitFear, '0') : '0',
                        'RES_FEAR': Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["f" /* getDefined */])(attribute.resFear, '0') : '0',

                        'remainStat': user.statPointInfo.remainStatPoint,
                        'remainTotalStat': user.statPointInfo.totalStatPoint,
                        'elixirStat': user.statPointInfo.remainElixirPoint,
                        'elixirTotalStat': user.statPointInfo.totalElixirPoint,

                        'elixirUseYN': user.statPointInfo.usedElixir
                  };

                  return json;
            }
      }]);

      return StatModel;
}();

/* harmony default export */ __webpack_exports__["a"] = (StatModel);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(8);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(44);
var enumBugKeys = __webpack_require__(31);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(30)('keys');
var uid = __webpack_require__(21);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(18);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BREAKPOINTS */
/* unused harmony export DAYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_DOMAIN_DEFAULT; });
/* unused harmony export API_COMMUNITY_DOMAIN */
/* unused harmony export STATIC_DOMAIN_DEFAULT */
/* unused harmony export STATIC_CDN_DOMAIN_DEFAULT */
/* unused harmony export NO_ITEM_IMAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PET_NECKLACE_ID; });
var BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

var DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

var API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

var API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

var STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

var STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

var NO_ITEM_IMAGE_URL = STATIC_DOMAIN_DEFAULT + '/lineage/v1/img/world/item/noimg.gif';

var PET_NECKLACE_ID = 25668;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  FAIL_RESET: '현재 스탯 초기화를 할 수 없습니다. 잠시 후, 다시 시도해주세요.',
  FAIL_LOAD_SAVED_STAT: '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.',

  CONFIRM_RESET: '초기화를 하면 레벨은 50으로, 입력하신 스탯포인트는 모두 베이스 스탯으로 초기화 됩니다.',

  CAN_SAVE_STAT_AFTER_LOGIN: '스탯 세팅 저장은 로그인 후 이용 가능합니다.',
  CAN_MODIFY_STAT_AFTER_LOGIN: '스탯 세팅 수정은 로그인 후 이용 가능합니다.',
  CAN_DELETE_STAT_AFTER_LOGIN: '스탯 세팅 삭제는 로그인 후 이용 가능합니다.',

  SAVE_STAT_LIMIT: '\uC2A4\uD0EF \uC138\uD305 \uC800\uC7A5\uC740 \uACC4\uC815\uB2F9 \uCD5C\uB300 6\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\n\uC0C8 \uC138\uD305 \uACB0\uACFC \uC800\uC7A5\uC744 \uC6D0\uD55C\uB2E4\uBA74 \uAE30\uC874 \uC800\uC7A5 \uB0B4\uC6A9 \uC0AD\uC81C \uD6C4 \uC774\uC6A9\uD574\uC8FC\uC138\uC694.\n\uC2A4\uD0EF \uC138\uD305\uC744 \uACC4\uC18D \uC9C4\uD589\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',

  TRY_DELETE_STAT: function TRY_DELETE_STAT(data) {
    return data.level + 'Lv \uC2A4\uD0EF \uC138\uD305\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?';
  },
  FAIL_DELETE_STAT: '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.',

  FAIL_SAVE_STAT: '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.',
  CAN_LEVELUP_AFTER_INIT_BASE_STAT: '베이스 스탯 포인트 분배 후에 레벨업하실 수 있습니다.',
  CAN_LEVELUP_AFTER_EXHAUST_REMAIN_STAT: '남은 스탯을 모두 사용하셔야 레벨업하실 수 있습니다.',
  CAN_PROCESS_AFTER_EXHAUST_ELIXIR_STAT: '엘릭서의 스탯을 모두 사용하셔야 다음 진행을 하실 수 있습니다.',
  FAIL_CALCULATE_STAT: '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.',

  COMPLETE_DISTRIBUTE_BASE_STAT: '\uBCA0\uC774\uC2A4 \uC2A4\uD0EF\uC744 \uBAA8\uB450 \uBD84\uBC30\uD558\uC168\uC2B5\uB2C8\uB2E4.\n\uC774\uC81C \uB808\uBCA8\uC5C5\uC73C\uB85C \uC6D0\uD558\uB294 \uC2A4\uD0EF\uC5D0\n\uBCF4\uB108\uC2A4 \uC2A4\uD0EF \uD3EC\uC778\uD2B8\uB97C \uBD84\uBC30\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',

  REMAIN_STAT_ZERO: '사용하실 수 있는 스탯 포인트를 모두 사용하셨습니다.',
  IMPOSSIBLE_LEVEL_CONSUME_ELIXIR_STAT: '엘릭서 스탯 포인트를 사용할 수 없는 레벨입니다.',
  NO_UNDO_STAT: '되돌릴 수 있는 스탯 포인트가 없습니다.',
  REQUIRE_EXHAUST_STAT: '남은 스탯 포인트를 모두 배분해주세요.'
};



/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var LIBRARY = __webpack_require__(16);
var wksExt = __webpack_require__(53);
var defineProperty = __webpack_require__(3).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadingBarTpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSectionTpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStatSimulatorTpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStatStorageItemTpl; });
var getLoadingBarTpl = function getLoadingBarTpl() {
  return '<div class="loadingbar"></div>';
};

var getSectionTpl = function getSectionTpl() {
  return '\n\t  <section class="variation variation__stat">\n\t\t\t<dl class="stat-STR">\n\t\t\t\t<dt class="STR"> <!-- em1, em2, em3 -->\n\t\t\t\t\t<strong>STR</strong>\n\t\t\t\t\t<span class="util">\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="down">-</button>{{?}}\n\t\t\t\t\t\t<var>{{=it.STR}}</var>\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="up">+</button>{{?}}\n\t\t\t\t\t</span>\n\t\t\t\t</dt>\n\t\t\t\t<dd>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li class="DAMAGE_SHORT"><label>\uADFC\uAC70\uB9AC \uB300\uBBF8\uC9C0</label><var>{{=it.DAMAGE_SHORT}}</var></li>\n            <li class="HIT_SHORT"><label>\uADFC\uAC70\uB9AC \uBA85\uC911</label><var>{{=it.HIT_SHORT}}</var></li>\n            <li class="FATAL_SHORT"><label>\uADFC\uAC70\uB9AC \uCE58\uBA85\uD0C0</label><var>{{=it.FATAL_SHORT}}</var></li>\n            <li class="WEIGHT"><label>\uCD5C\uB300 \uC18C\uC9C0 \uBB34\uAC8C</label><var>{{=it.WEIGHT}}</var></li>\n\t\t\t\t\t</ul>\n\t\t\t\t</dd>\n\t\t\t</dl>\n\n\t\t\t<dl class="stat-DEX">\n\t\t\t\t<dt class="DEX">\n\t\t\t\t\t<strong>DEX</strong>\n\t\t\t\t\t<span class="util">\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="down">-</button>{{?}}\n\t\t\t\t\t\t<var>{{=it.DEX}}</var>\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="up">+</button>{{?}}\n\t\t\t\t\t</span>\n\t\t\t\t</dt>\n\t\t\t\t<dd>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li class="DAMAGE_LONG"><label>\uC6D0\uAC70\uB9AC \uB300\uBBF8\uC9C0</label><var>{{=it.DAMAGE_LONG}}</var></li>\n            <li class="HIT_LONG"><label>\uC6D0\uAC70\uB9AC \uBA85\uC911</label><var>{{=it.HIT_LONG}}</var></li>\n            <li class="FATAL_LONG"><label>\uC6D0\uAC70\uB9AC \uCE58\uBA85\uD0C0</label><var>{{=it.FATAL_LONG}}</var></li>\n            <li class="AC"><label>\uBB3C\uB9AC \uBC29\uC5B4\uB825(AC)</label><var>{{=it.AC}}</var></li>\n            <li class="ER"><label>\uC6D0\uAC70\uB9AC \uD68C\uD53C\uB825(ER)</label><var>{{=it.ER}}</var></li>\n\t\t\t\t\t</ul>\n\t\t\t\t</dd>\n\t\t\t</dl>\n\t\t\t\n\t\t\t<dl class="stat-INT">\n\t\t\t\t<dt class="INT">\n\t\t\t\t\t<strong>INT</strong>\n\t\t\t\t\t<span class="util">\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="down">-</button>{{?}}\n\t\t\t\t\t\t<var>{{=it.INT}}</var>\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="up">+</button>{{?}}\n\t\t\t\t\t</span>\n\t\t\t\t</dt>\n\t\t\t\t<dd>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li class="DAMAGE_WIZ"><label>\uB9C8\uBC95 \uB300\uBBF8\uC9C0</label><var>{{=it.DAMAGE_WIZ}}</var></li>\n            <li class="HIT_WIZ"><label>\uB9C8\uBC95\uC801\uC911</label><var>{{=it.HIT_WIZ}}</var></li>\n            <li class="FATAL_WIZ"><label>\uB9C8\uBC95 \uCE58\uBA85\uD0C0</label><var>{{=it.FATAL_WIZ}}</var></li>\n            <li class="MB"><label>\uB9C8\uBC95 \uBCF4\uB108\uC2A4(MB)</label><var>{{=it.MB}}</var></li>\n            <li class="MP_MINUS"><label>MP \uC18C\uBAA8 \uAC10\uC18C</label><var>{{=it.MP_MINUS}}</var></li>\n\t\t\t\t\t</ul>\n\t\t\t\t</dd>\n\t\t\t</dl>\n\t\t\t\n\t\t\t<dl class="stat-WIS">\n\t\t\t\t<dt class="WIS">\n\t\t\t\t\t<strong>WIS</strong>\n\t\t\t\t\t<span class="util">\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="down">-</button>{{?}}\n\t\t\t\t\t\t<var>{{=it.WIS}}</var>\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="up">+</button>{{?}}\n\t\t\t\t\t</span>\n\t\t\t\t</dt>\n\t\t\t\t<dd>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li class="LEVELUP_MP_PLUS"><label>\uB808\uBCA8\uC5C5\uC2DC MP \uC99D\uAC00</label><var>{{=it.LEVELUP_MP_PLUS_MIN}} ~ {{=it.LEVELUP_MP_PLUS_MAX}}</var></li>\n            <li class="MP_RECOVER_TIC"><label>MP \uD68C\uBCF5(\uD2F1)</label><var>{{=it.MP_RECOVER_TIC}}</var></li>\n            <li class="MP_RECOVER_LIQUOR"><label>MP \uBB3C\uC57D \uD68C\uBCF5(\uD2F1)</label><var>{{=it.MP_RECOVER_LIQUOR}}</var></li>\n            <li class="MR"><label>\uB9C8\uBC95 \uBC29\uC5B4\uB825(MR)</label><var>{{=it.MR}}</var></li>\n\t\t\t\t\t</ul>\n\t\t\t\t</dd>\n\t\t\t</dl>\n\n\t\t\t<dl class="stat-CON">\n\t\t\t\t<dt class="CON">\n\t\t\t\t\t<strong>CON</strong>\n\t\t\t\t\t<span class="util">\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="down">-</button>{{?}}\n\t\t\t\t\t\t<var>{{=it.CON}}</var>\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="up">+</button>{{?}}\n\t\t\t\t\t</span>\n\t\t\t\t</dt>\n\t\t\t\t<dd>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li class="HP_PLUS"><label>\uB808\uBCA8\uC5C5\uC2DC HP \uC99D\uAC00</label><var>{{=it.LEVELUP_HP_PLUS_MIN}} ~ {{=it.LEVELUP_HP_PLUS_MAX}}</var></li>\n            <li class="HP_RECOVER_TIC"><label>HP \uD68C\uBCF5(\uD2F1)</label><var>{{=it.HP_RECOVER_TIC_MIN}} ~ {{=it.HP_RECOVER_TIC_MAX}}</var></li>\n            <li class="HP_RECOVER_LIQUOR"><label>HP \uBB3C\uC57D \uD68C\uBCF5 \uC99D\uAC00</label><var>{{=it.HP_RECOVER_LIQUOR}}</var></li>\n            <li class="WEIGHT"><label>\uCD5C\uB300 \uC18C\uC9C0 \uBB34\uAC8C</label><var>{{=it.WEIGHT}}</var></li>\n\t\t\t\t\t</ul>\n\t\t\t\t</dd>\n\t\t\t</dl>\n\n\t\t\t<dl class="stat-CHA">\n\t\t\t\t<dt class="CHA">\n\t\t\t\t\t<strong>CHA</strong>\n\t\t\t\t\t<span class="util">\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="down">-</button>{{?}}\n\t\t\t\t\t\t<var>{{=it.CHA}}</var>\n\t\t\t\t\t\t{{? it.page === "default" || it.page === \'modify\' }}<button class="up">+</button>{{?}}\n\t\t\t\t\t</span>\n\t\t\t\t</dt>\n\t\t\t\t<dd>\n                  <ul>\n                    <li class="CHA_HIT_SIKII"><label>\uAE30\uC220 \uC801\uC911</label><var>{{=it.CHA_HIT_SIKII}}</var></li>\n                    <li class="CHA_HIT_SUMMON"><label>\uC815\uB839 \uC801\uC911</label><var>{{=it.CHA_HIT_SUMMON}}</var></li>\n                    <li class="CHA_HIT_DRAGON"><label>\uC6A9\uC5B8 \uC801\uC911</label><var>{{=it.CHA_HIT_DRAGON}}</var></li>\n                    <li class="CHA_HIT_FEAR"><label>\uACF5\uD3EC \uC801\uC911</label><var>{{=it.CHA_HIT_FEAR}}</var></li>\n                    <li class="CHA_SKILL_TIME_REDUCTION"><label>\uC2A4\uD0AC \uCFE8\uD0C0\uC784 \uAC10\uC18C</label><var>{{=it.CHA_SKILL_TIME_REDUCTION}}</var></li>\n                    <li class="CHA_STATUS_TIME_REDUCTION"><label>\uC0C1\uD0DC \uC774\uC0C1 \uC2DC\uAC04 \uAC10\uC18C</label><var>{{=it.CHA_STATUS_TIME_REDUCTION}}</var></li>\n                  </ul>\n                </dd>\n\t\t\t</dl>\n\t  </section>';
};

var getStatSimulatorTpl = function getStatSimulatorTpl() {
  // 2022.01. 레벨 추가
  return '<section class="simulator__stat" tabindex="0">\n    <header>\n      <span class="icon-back" title="\uB4A4\uB85C"></span>\n      <h3></h3>\n        <div class="util">\n          {{? it.page === "default" || it.page === \'modify\' }}\n            <button class="btn-save">\uC800\uC7A5</button>\n            <button class="btn-reset">\uCD08\uAE30\uD654</button>\n\n          {{?? it.page === "view" }}\n            <button class="btn-modify">\uC218\uC815</button>\n            <button class="btn-delete">\uC0AD\uC81C</button>\n          {{?}}\n        </div>\n    </header>\n\n    <section class="char char__stat">\n      <div class="base">\n        <img src="{{=it.classImageUrl}}" class="thumb" />\n        <span class="name"></span>\n        <span class="server"></span>\n        <span class="level"><strong>{{=it.level}}</strong>Lv.</span>\n        <span class="level_target"><strong>{{=it.targetLevel}}</strong>Lv.</span>\n      </div>\n\n      {{? it.page === "default" || it.page === \'modify\' }}\n      <div class="wrap-button">\n        <button class="button btn-levelup">\uB808\uBCA8 UP</button>\n        <div class="tooltip-levelup"></div>\n      </div>\n\n      <div class="point">\n        <p><label>\uB0A8\uC740 \uC2A4\uD0EF</label><var><strong class="em">{{=it.remainStat}}</strong><span class="total">({{=it.remainTotalStat}})</span></var></p>\n        <p class="elixir"><span class="custom-checkbox"><input type="checkbox" name="ELIXIR_POINT" id="ELIXIR_POINT" value=""></span><label for="ELIXIR_POINT">\uC5D8\uB9AD\uC11C \uC2A4\uD0EF</label><var><strong>{{=it.elixirStat}}</strong><span class="total">({{=it.elixirTotalStat}})</span></var></p>\n      </div>\n      {{?}}\n\n      <div class="hpmp">\n        <ul>\n          <li class="hp">\n            <label>HP</label>\n            <span class="graph"><figure style="width:100%"></figure></span>\n            <var>{{=it.HP}}</var>\n          </li>\n\n          <li class="mp">\n            <label>MP</label>\n            <span class="graph"><figure style="width:100%"></figure></span>\n            <var>{{=it.MP}}</var>\n          </li>\n        </ul>\n      </div>\n    </section>\n\n    ' + getSectionTpl() + '\n\n    {{? it.page === "default" || it.page === \'modify\' }}\n    <footer>\n      <p>PC\uC5D0\uC11C\uB294 \uD0A4\uBCF4\uB4DC\uC758 [V]\uBC84\uD2BC\uC73C\uB85C \uAC04\uD3B8\uD558\uAC8C \uB808\uBCA8\uC5C5 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.</p>\n    </footer>\n    {{?}}\n  </section>';
};

var getStatStorageItemTpl = function getStatStorageItemTpl() {
  var hasDeleteBtn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var deleteBtnTpl = hasDeleteBtn === true ? '<button class="btn-delete" title="delete"></button>' : '';

  return '<article class="storage__stat" data-idx="{{=it.idx}}" data-class-id="{{=it.classId}}" data-level="{{=it.level}}" data-hp="{{=it.hp}}" data-mp="{{=it.mp}}" >\n    <div class="char">\n      <img src="{{=it.classImageUrl}}" class="thumb">\n      <span class="name"></span>\n      <span class="server"></span>\n      <span class="level">{{=it.level}}Lv.</span>\n      <span class="date">{{=it.date}}</span>\n    </div>\n\n    <div class="stat">\n      <ul>\n        <li class="stat-STR">\n          <label>STR</label>\n          <span class="graph"><figure style="width:{{=it.percentageSTR}}"></figure></span>\n          <var>{{=it.statMetaInfo.mainStat.STR}}</var>\n        </li>\n        <li class="stat-DEX">\n          <label>DEX</label>\n          <span class="graph"><figure style="width:{{=it.percentageDEX}}"></figure></span>\n          <var>{{=it.statMetaInfo.mainStat.DEX}}</var>\n        </li>\n        <li class="stat-INT">\n          <label>INT</label>\n          <span class="graph"><figure style="width:{{=it.percentageINT}}"></figure></span>\n          <var>{{=it.statMetaInfo.mainStat.INT}}</var>\n        </li>\n        <li class="stat-WIS">\n          <label>WIS</label>\n          <span class="graph"><figure style="width:{{=it.percentageWIS}}"></figure></span>\n          <var>{{=it.statMetaInfo.mainStat.WIS}}</var>\n        </li>\n        <li class="stat-CON">\n          <label>CON</label>\n          <span class="graph"><figure style="width:{{=it.percentageCON}}"></figure></span>\n          <var>{{=it.statMetaInfo.mainStat.CON}}</var>\n        </li>\n        <li class="stat-CHA">\n          <label>CHA</label>\n          <span class="graph"><figure style="width:{{=it.percentageCHA}}"></figure></span>\n          <var>{{=it.statMetaInfo.mainStat.CHA}}</var>\n        </li>\n      </ul>\n    </div>\n\n    ' + deleteBtnTpl + '\n  </article>';
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(66), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports) {



/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(16);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(42);
var hide = __webpack_require__(7);
var has = __webpack_require__(9);
var Iterators = __webpack_require__(14);
var $iterCreate = __webpack_require__(69);
var setToStringTag = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(74);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(26)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4);
var dPs = __webpack_require__(70);
var enumBugKeys = __webpack_require__(31);
var IE_PROTO = __webpack_require__(29)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(26)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(46).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(9);
var toIObject = __webpack_require__(13);
var arrayIndexOf = __webpack_require__(72)(false);
var IE_PROTO = __webpack_require__(29)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(24);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(15);
var TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(18);
var SPECIES = __webpack_require__(1)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(17);
var invoke = __webpack_require__(86);
var html = __webpack_require__(46);
var cel = __webpack_require__(26);
var global = __webpack_require__(0);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(15)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(32);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(103), __esModule: true };

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(1);


/***/ }),
/* 54 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(44);
var hiddenKeys = __webpack_require__(31).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);



var singletonId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default()();
var singletonEnforcer = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default()();

var SingletonLoading = function () {
  function SingletonLoading(enforcer) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SingletonLoading);

    if (enforcer !== singletonEnforcer) {
      throw new Error('SingletonLoading can not use construct.');
    }

    this.loadingBar = null;

    this._isLoading = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SingletonLoading, [{
    key: 'setLoadingBar',
    value: function setLoadingBar(element) {
      this.loadingBar = $(element);

      return this;
    }
  }, {
    key: 'start',
    value: function start() {
      var _ = this;

      _.loadingBar.show();

      _._isLoading = true;

      console.log('loading start');

      return _;
    }
  }, {
    key: 'end',
    value: function end() {
      var _ = this;

      _.loadingBar.hide();

      _._isLoading = false;

      console.log('loading end');

      return _;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this._isLoading;
    }
  }], [{
    key: 'getInstance',
    value: function getInstance() {
      if (!this[singletonId]) this[singletonId] = new SingletonLoading(singletonEnforcer);
      return this[singletonId];
    }
  }]);

  return SingletonLoading;
}();

/* harmony default export */ __webpack_exports__["a"] = (SingletonLoading);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClassDefaultStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return saveNewUserStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSavedUserStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSavedUserStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return saveUserStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteUserStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateStatByLevelUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateStat; });
/* unused harmony export getSavedUserEquips */
/* unused harmony export getSavedUserEquip */
/* unused harmony export getUserStats */
/* unused harmony export getUserSlotsStatus */
/* unused harmony export getUserEquips */
/* unused harmony export getMyCharacters */
/* unused harmony export getSearchEquipItems */
/* unused harmony export getStatNoEquips */
/* unused harmony export getStatReflectEquips */
/* unused harmony export saveNewEquip */
/* unused harmony export saveExistingEquip */
/* unused harmony export deleteSavedEquip */
/* unused harmony export getEquipItemPrice */
/* unused harmony export getItemStatisticSummary */
/* unused harmony export getAffectStats */
/* unused harmony export getStatArticleDetails */
/* unused harmony export getEquipArticleDetails */
/* unused harmony export getCommunityCategory */
/* unused harmony export setOrgStats */
/* unused harmony export getOrgStats */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


var $ = jQuery;

/*
 * stat
 */
var getSavedUserStats = function getSavedUserStats() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/stat/user',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getSavedUserStats error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757
// https://wiki.ncsoft.com/pages/viewpage.action?pageId=305141971 20201017 API path 수정됨

var getClassDefaultStat = function getClassDefaultStat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', classId: '', targetLevel: '', beforeSend: null };
  // 2022.01 targetLevel 추가
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/stat/' + options.classId + '/default?targetLevel=' + options.targetLevel,
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getClassDefaultStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getSavedUserStat = function getSavedUserStat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', idx: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/stat/user/' + options.idx,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getSavedUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-POST/web/simulator/stat/user
var saveNewUserStat = function saveNewUserStat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'POST',
      url: options.apiDomain + '/web/simulator/stat/user',
      contentType: 'application/json',
      dataType: 'json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('saveNewUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var saveUserStat = function saveUserStat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', idx: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: options.apiDomain + '/web/simulator/stat/user/' + options.idx,
      contentType: 'application/json',
      dataType: 'json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('saveUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var deleteUserStat = function deleteUserStat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', idx: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'DELETE',
      url: options.apiDomain + '/web/simulator/stat/user/' + options.idx,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('deleteUserStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var calculateStatByLevelUp = function calculateStatByLevelUp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', classId: '', level: 1, sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: options.apiDomain + '/web/simulator/stat/class/' + options.classId + '/level/' + options.level,
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('calculateStatByLevelUp error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var calculateStat = function calculateStat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', classId: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: options.apiDomain + '/web/simulator/stat/class/' + options.classId,
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      contentType: 'application/json',
      dataType: 'json',
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('calculateStat error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

/*
 * equip
 */
var getStatNoEquips = function getStatNoEquips() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', sendData: null, beforeSend: null };
  // final_stats 2019.
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: options.apiDomain + '/web/simulator/equip/class/' + options.sendData.classId + '/final_stats',
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      dataType: 'json',
      cache: false,
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getStatNoEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=91226365#WebDev-리니지RWDAPI-My-GET/api/my/characters
var getMyCharacters = function getMyCharacters() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/api/my/characters',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getMyCharacters error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getSavedUserEquips = function getSavedUserEquips() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/equip/user',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      cache: false,
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getSavedUserEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getSavedUserEquip = function getSavedUserEquip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', idx: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/equip/user/' + options.idx,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getSavedUserEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getUserStats = function getUserStats() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', serverId: '', characterName: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/equip/servers/' + options.serverId + '/characters/' + options.characterName + '/stat',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getUserStats error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getUserSlotsStatus = function getUserSlotsStatus() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', serverId: '', characterName: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/equip/servers/' + options.serverId + '/characters/' + options.characterName + '/slot',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getUserSlotsStatus error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getUserEquips = function getUserEquips() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', serverId: '', characterName: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/equip/servers/' + options.serverId + '/characters/' + options.characterName + '/equipments',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getUserEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getSearchEquipItems = function getSearchEquipItems() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', sendData: null, beforeSend: null };

  // console.log('getSearchEquipItems() JSON.stringify(options.sendData) : ', JSON.stringify(options.sendData) , 'options.sendData : ', options.sendData );
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/search/equipment',
      contentType: 'application/json',
      data: options.sendData, // JSON.stringify(options.sendData), post -> get
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getSearchEquipItems() error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getStatReflectEquips = function getStatReflectEquips() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: options.apiDomain + '/web/simulator/equip/class/' + options.sendData.classId + '/item',
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getStatReflectEquips error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var saveNewEquip = function saveNewEquip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'POST',
      url: options.apiDomain + '/web/simulator/equip/user',
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('saveNewEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-PUT/web/simulator/equip/user/:idx
var saveExistingEquip = function saveExistingEquip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', idx: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'PUT',
      url: options.apiDomain + '/web/simulator/equip/user/' + options.idx,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options.sendData),
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('saveExistingEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var deleteSavedEquip = function deleteSavedEquip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', idx: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'DELETE',
      url: options.apiDomain + '/web/simulator/equip/user/' + options.idx,
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('deleteSavedEquip error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=89740552#WebDev-리니지RWDAPI-MarketPrice-GET/api/marketprice/trade/currentStatisticSummary
var getEquipItemPrice = function getEquipItemPrice() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/api/marketprice/trade/currentStatisticSummary',
      contentType: 'application/json',
      dataType: 'json',
      data: options.sendData, // {serverId, itemId, enchant}
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getEquipItemPrice error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=89740552#WebDev-리니지RWDAPI-MarketPrice-GET/api/marketprice/trade/currentStatisticSummary
var getItemStatisticSummary = function getItemStatisticSummary() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/api/marketprice/trade/currentStatisticSummary',
      contentType: 'application/json',
      dataType: 'json',
      data: options.sendData,
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getItemStatisticSummary error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getAffectStats = function getAffectStats() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', itemId: '', enchant: '', sendData: null, beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/web/simulator/equip/items/' + options.itemId + '/enchant/' + options.enchant + '/affectStats',
      contentType: 'application/json',
      dataType: 'json',
      data: options.sendData,
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getAffectStats error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// qna board
// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/web/simulator/stat/article/:articleId/details
var getStatArticleDetails = function getStatArticleDetails() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', articleId: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/board/simulator/stat/article/' + options.articleId + '/details',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getStatArticleDetails error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

// http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/web/simulator/stat/article/:articleId/details
var getEquipArticleDetails = function getEquipArticleDetails() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', articleId: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/board/simulator/equip/article/' + options.articleId + '/details',
      contentType: 'application/json',
      dataType: 'json',
      xhrFields: { withCredentials: true },
      beforeSend: options.beforeSend || null

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getEquipArticleDetails error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var getCommunityCategory = function getCommunityCategory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { apiDomain: '', beforeSend: null };

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      type: 'GET',
      url: options.apiDomain + '/board/simulator/category.json',
      contentType: 'application/json',
      dataType: 'json'

    }).done(function (data, textStatus, jqXHR) {
      resolve(data, textStatus, jqXHR);
    }).fail(function (jqXHR, textStatus, errorThrown) {
      var error = new Error('getCommunityCategory error');
      error.jqXHR = jqXHR;

      reject(error);
    });
  });
};

var _orgStats = {};

var setOrgStats = function setOrgStats() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: null };

  return _orgStats = options.data;
};

var getOrgStats = function getOrgStats() {
  return _orgStats;
};



/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDatas */
/* unused harmony export getDatasWithOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleApiError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_alert__ = __webpack_require__(115);


var getDatas = function getDatas(urls, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = urls.length; i < max; i++) {
    var promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var getDatasWithOption = function getDatasWithOption(jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    var promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var handleApiError = function handleApiError(apiResultData) {
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(__WEBPACK_IMPORTED_MODULE_0__model_msg_alert__["a" /* ALERT */].REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};



/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(60);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__characterSetting_stat_Stat__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(12);



(function ($) {
  "use strict";

  // import doT.js

  __webpack_require__(118);

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["p" /* namespace */])('nc.lineage');

  nc.lineage.statSetting = function (options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["m" /* isNotDefined */])(options)) throw new Error('nc.lineage.statSetting require options object');

    return new __WEBPACK_IMPORTED_MODULE_0__characterSetting_stat_Stat__["a" /* default */](options).init();
  };
})(jQuery);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatSimulator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StatModel__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_SingletonLoading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_msg_stat__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_tpl_stat__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_model__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);















var Stat = function () {
  function Stat(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Stat);

    var _ = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["m" /* isNotDefined */])(options)) throw new Error('Stat constructor require options object');

    _.option = $.extend({
      deviceType: '',
      wrap: null,
      staticDomain: '',
      apiDomain: __WEBPACK_IMPORTED_MODULE_12__model_model__["a" /* API_DOMAIN_DEFAULT */],
      isLogin: false,
      global: window
    }, options);

    _.model = __WEBPACK_IMPORTED_MODULE_5__StatModel__["a" /* default */].getInstance();

    _.loading = __WEBPACK_IMPORTED_MODULE_6__utils_SingletonLoading__["a" /* default */].getInstance();

    _.wrap = null;

    _.simulatorWrap = null;
    _.classLayer = null;
    _.storageWrap = null;
    _.displayNoStorageItem = null;

    _.stat = null;

    _.global = _.option.global;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Stat, [{
    key: 'init',
    value: function init() {
      var _ = this;

      _.wrap = $(_.option.wrap);

      if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["r" /* notSingleEle */])(_.wrap)) throw new Error('wrap must be single element.');

      _.model.DEVICE_TYPE = _.option.deviceType;

      _.simulatorWrap = $('.wrap-simulator', _.wrap);
      _.classLayer = $('.simulator-select', _.wrap);
      _.storageWrap = $('.simulator-storage', _.wrap);
      _.displayNoStorageItem = $('.nodata', _.wrap);

      _.setInstance();

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance() {
      var _ = this;

      _.setLoadingBar();
      _.setBtns();
      _.setClassLayer();

      if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(_.option.isLogin)) {
        // _.showNoStorageItems(false, false);
        _.setStorage();
      }
    }
  }, {
    key: 'setLoadingBar',
    value: function setLoadingBar() {
      var _ = this;

      $('.wrap-contents', _.wrap).append(Object(__WEBPACK_IMPORTED_MODULE_10__model_tpl_stat__["a" /* getLoadingBarTpl */])());

      _.loading.setLoadingBar($('.loadingbar', _.wrap));
      _.loading.end();
    }
  }, {
    key: 'setBtns',
    value: function setBtns() {
      var _ = this;

      $('.btn-simulator', _.wrap).on('click', function (evt) {
        evt.preventDefault();

        if (_.getSavedUserStatNum() >= _.model.USER_STAT_NUM_LIMIT) {
          var isConfirmSimulateStat = _.global.confirm(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].SAVE_STAT_LIMIT); // 스탯 세팅 저장은 계정당 최대 6개까지 가능합니다. 새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요. 스탯 세팅을 계속 진행하시겠습니까?

          if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(isConfirmSimulateStat)) {
            _.showClassLayer(true);
            _.showStorage(false);
          }
        } else {
          _.showClassLayer(true);
          _.showStorage(false);
        }
      });

      // before login
      $('.btn-login', _.wrap).on('click', function (evt) {
        evt.preventDefault();

        if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["k" /* isFunction */])(_.global.GNBLogin)) _.global.GNBLogin();
      });
    }
  }, {
    key: 'setClassLayer',
    value: function setClassLayer() {
      var _ = this;

      $('.btn-close', _.classLayer).on('click', function (evt) {
        evt.preventDefault();

        _.showClassLayer(false);
        _.showStorage(true);
      });

      // 2022.01 스탯 > 레벨 추가
      $('article ul li', _.classLayer).on('click', function (evt) {
        evt.preventDefault();
        $(".simulator-select-class-article ul li.is-selected").removeClass("is-selected");
        $(this).addClass("is-selected");
      });

      // 2022.01 스탯 > 레벨 추가
      $('.simulator-select-level-article .btn-submit', _.classLayer).on('click', function (evt) {
        evt.preventDefault();
        var classId = $('.simulator-select-class-article ul li[class="is-selected"]').attr('data-class');
        var targetLevel = $('.simulator-select-level-article input[name="targetLevel"]').val();

        if (!classId) {
          alert('클래스를 선택해주세요.');
          return false;
        }
        if (!targetLevel) {
          alert('50~100 사이의 원하는 레벨을 숫자만 입력해 주세요.');
          $('.simulator-select-level-article input[name="targetLevel"]').focus();
          return false;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["n" /* isNumber */])(parseInt(targetLevel)) || !Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["n" /* isNumber */])(parseInt(targetLevel)) || parseInt(targetLevel) < 50 || parseInt(targetLevel) > 100) {
          alert('정확한 레벨을 입력해 주세요.');
          $('.simulator-select-level-article input[name="targetLevel"]').focus();
          return false;
        }

        _.setClassDefaultStat(classId, targetLevel); // 2022.01 스탯 시작 클릭
      });
    }
  }, {
    key: 'setStorage',
    value: function setStorage() {
      var _ = this;

      _.setStorageItemsEvent(false);

      var storageListWrap = $('.storage-bundle', _.wrap);
      $('.storage__stat', storageListWrap).remove();

      if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

      // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/user
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_service__["f" /* getSavedUserStats */])({
        apiDomain: _.option.apiDomain,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        console.log('getSavedUserStat - data :', data);
        _.loading.end();

        if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(Array.isArray(data))) {
          if (data.length > 0) {
            // sort by descending date order
            data.sort(function (a, b) {
              return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime();
            });
            // const statMax = _.model.STAT_MAX; // 2019.11

            var mainStat = null,
                itemsTpl = '';
            Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["c" /* each */])(data, function (item) {

              // 2021.12
              // const statMax = (item.level >= _.model.LEVEL_CHANGE_STAT_MAX ) ? _.model.CHANGED_STAT_MAX : _.model.STAT_MAX;  // 2019.11
              // 2022.01 .level-> .targetLevel
              var statMax = Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["h" /* getStatMaxByLevel */])(parseInt(item.targetLevel), _.model.STAT_MAX_BY_LEVEL);

              item.idx = item.idx;
              item.classId = item.classId;
              item.date = _.getDateStr(item.updateDate);
              item.hp = item.statMetaInfo.hp;
              item.mp = item.statMetaInfo.mp;

              mainStat = item.statMetaInfo.mainStat;

              for (var stat in mainStat) {
                if (mainStat[stat] > statMax) mainStat[stat] = statMax;
              }item.percentageSTR = mainStat.STR / statMax * 100 + '%';
              item.percentageDEX = mainStat.DEX / statMax * 100 + '%';
              item.percentageINT = mainStat.INT / statMax * 100 + '%';
              item.percentageWIS = mainStat.WIS / statMax * 100 + '%';
              item.percentageCON = mainStat.CON / statMax * 100 + '%';
              item.percentageCHA = mainStat.CHA / statMax * 100 + '%';

              var itemTplFunc = doT.template(Object(__WEBPACK_IMPORTED_MODULE_10__model_tpl_stat__["d" /* getStatStorageItemTpl */])(true)),
                  itemTpl = itemTplFunc(item);

              itemsTpl += itemTpl;
            });

            storageListWrap.prepend(itemsTpl);

            _.setStorageItemsEvent(true);

            _.showNoStorageItems(false);
          } else {
            _.showNoStorageItems(true);
          }
        } else {
          _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
        }
      }).catch(function (err) {
        _.loading.end();
        if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'setClassDefaultStat',
    value: function setClassDefaultStat(classId, targetLevel) {
      // 2022.01
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

      console.log("=> Stat.js, classId,targetLevel", classId, targetLevel);

      Object(__WEBPACK_IMPORTED_MODULE_8__utils_service__["d" /* getClassDefaultStat */])({
        apiDomain: _.option.apiDomain,
        classId: classId,
        targetLevel: targetLevel,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        console.log('=> Stat.js, setClassDefaultStat() data :', data);

        _.loading.end();

        _.showSimulatorWrap(false);

        _.showClassLayer(false);

        _.setStatSimulator('default', classId, targetLevel, data);
      }).catch(function (err) {
        _.loading.end();

        if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_RESET); // '현재 스탯 초기화를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'setStorageItemsEvent',
    value: function setStorageItemsEvent(flag) {
      var _ = this,
          items = $('.storage-bundle .storage__stat', _.wrap);

      items.each(function (index, item) {
        if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(flag)) {
          $(item).on('click', function (evt) {
            evt.preventDefault();

            if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

            _.loading.start();

            var classId = $(item).attr('data-class-id'),
                idx = $(this).attr('data-idx'),
                level = $(this).attr('data-level');

            if ($(evt.target).hasClass('btn-delete')) {
              if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["o" /* isString */])(idx), idx !== '')) {
                var msg = __WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].TRY_DELETE_STAT({ level: level }),
                    isConfirmDeleteStat = _.global.confirm(msg); // ${0}Lv 스탯 세팅을 삭제하시겠습니까?

                isConfirmDeleteStat ? _.deleteStatSetting(idx) : _.loading.end();
              }

              return;
            }

            // get result call getClassDefaultStat, getSavedUserStat
            // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/:classId/default
            // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/stat/user/:idx
            _.setStatSimulatorByApi(classId, level, idx);
          });
        } else {
          $(item).off('click');
        }
      });
    }
  }, {
    key: 'deleteStatSetting',
    value: function deleteStatSetting(idx) {
      var _ = this;

      // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-DELETE/api/simulator/stat/user/:idx
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_service__["c" /* deleteUserStat */])({
        apiDomain: _.option.apiDomain,
        idx: idx,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        _.loading.end();

        if (data.result === 'success') {
          // remove stat item
          $('.storage-bundle .storage__stat', _.option.wrap).filter(function () {
            return $(this).attr('data-idx') === idx;
          }).remove();

          _.showNoStorageItems($('section article.storage__stat').length < 1);
        } else {
          if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* handleApiError */])(data))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
        }
      }).catch(function (err) {
        _.loading.end();

        if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* handleApiError */])(jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'setStatSimulatorByApi',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(classId, targetLevel, idx) {
        var _, classDefaultStat, savedUserStat, viewPageData;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ = this;
                _context.prev = 1;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_service__["d" /* getClassDefaultStat */])({ // 2021.01 스탯 세팅 호출 targetLevel 추가
                  apiDomain: _.option.apiDomain,
                  classId: classId,
                  targetLevel: targetLevel
                });

              case 4:
                classDefaultStat = _context.sent;
                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_service__["e" /* getSavedUserStat */])({
                  apiDomain: _.option.apiDomain,
                  idx: idx
                });

              case 7:
                savedUserStat = _context.sent;


                _.loading.end();

                _.showSimulatorWrap(false);

                _.showClassLayer(false);

                viewPageData = __WEBPACK_IMPORTED_MODULE_5__StatModel__["a" /* default */].getSavedStatData(savedUserStat.simulationStat, savedUserStat.userStatInfo, {
                  'idx': idx,
                  'page': 'view',
                  'type': _.model.DEVICE_TYPE
                });


                console.log('setStatSimulatorByApi - classDefaultStat :', classDefaultStat);
                console.log('setStatSimulatorByApi - savedUserStat :', savedUserStat);

                _.setStatSimulator(viewPageData.page, savedUserStat.userStatInfo.classId, savedUserStat.userStatInfo.targetLevel, viewPageData, classDefaultStat);

                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](1);

                _.loading.end();

                if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* handleApiError */])(_context.t0.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 17]]);
      }));

      function setStatSimulatorByApi(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return setStatSimulatorByApi;
    }()

    // 2022.01 레벨 추가

  }, {
    key: 'setStatSimulator',
    value: function setStatSimulator(page, classId, targetLevel, data) {
      var classDefaultStatData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var _ = this;

      _.stat = new __WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */]({
        staticDomain: _.option.staticDomain,
        apiDomain: _.option.apiDomain,
        classId: classId,
        // level : targetLevel,
        targetLevel: targetLevel,
        page: page, // default, view, modify
        wrap: $('.wrap-simulator-body', _.wrap),
        data: data,
        classDefaultStatData: classDefaultStatData,
        isLogin: _.option.isLogin,
        savedUserStatNum: _.getSavedUserStatNum()
      }).init();

      console.log('=> Stat.js setStatSimulator() _.stat : ', _.stat);
      $(_.stat).on(__WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */].EVT_CLOSE, function (evt) {
        _.destroyStatSimulator();
        _.showStorage(true);
        _.showSimulatorWrap(true);
      }).on(__WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */].EVT_SAVE_STAT_COMPLETE, function (evt) {
        _.destroyStatSimulator();
        _.setStorage();
        _.showStorage(true);
        _.showSimulatorWrap(true);
      }).on(__WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */].EVT_DELETE_STAT_COMPLETE, function (evt) {
        _.destroyStatSimulator();
        _.setStorage();
        _.showStorage(true);
        _.showSimulatorWrap(true);
      });
    }
  }, {
    key: 'showSimulatorWrap',
    value: function showSimulatorWrap(flag) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(flag) ? this.simulatorWrap.show() : this.simulatorWrap.hide();
    }
  }, {
    key: 'showClassLayer',
    value: function showClassLayer(flag) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(flag) ? this.classLayer.show() : this.classLayer.hide();
    }
  }, {
    key: 'showStorage',
    value: function showStorage(flag) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(flag) ? this.storageWrap.show() : this.storageWrap.hide();
    }
  }, {
    key: 'showNoStorageItems',
    value: function showNoStorageItems(flag) {
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(flag) ? this.displayNoStorageItem.show() : this.displayNoStorageItem.hide();
      Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["u" /* truthy */])(flag) ? $('.simulator-storage footer').hide() : $('.simulator-storage footer').show();
    }
  }, {
    key: 'getDateStr',
    value: function getDateStr(dateStr) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY.MM.DD';

      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(dateStr).format(format);
    }
  }, {
    key: 'getSavedUserStatNum',
    value: function getSavedUserStatNum() {
      return $('.storage-bundle .storage__stat', this.wrap).length;
    }
  }, {
    key: 'destroyStatSimulator',
    value: function destroyStatSimulator() {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_11__utils_util__["j" /* isDefined */])(_.stat)) {
        $(_.stat).off(__WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */].EVT_CLOSE).off(__WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */].EVT_SAVE_STAT_COMPLETE).off(__WEBPACK_IMPORTED_MODULE_4__StatSimulator__["a" /* default */].EVT_DELETE_STAT_COMPLETE);

        _.stat.destroy();
        _.stat = null;
      }
    }
  }]);

  return Stat;
}();

/* harmony default export */ __webpack_exports__["a"] = (Stat);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(64);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(38);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39);
__webpack_require__(67);
__webpack_require__(76);
__webpack_require__(80);
__webpack_require__(91);
__webpack_require__(92);
module.exports = __webpack_require__(2).Promise;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(68)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(40)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(24);
var defined = __webpack_require__(25);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(43);
var descriptor = __webpack_require__(20);
var setToStringTag = __webpack_require__(22);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(7)(IteratorPrototype, __webpack_require__(1)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(3);
var anObject = __webpack_require__(4);
var getKeys = __webpack_require__(28);

module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(15);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(13);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(73);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(24);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(9);
var toObject = __webpack_require__(75);
var IE_PROTO = __webpack_require__(29)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(25);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
var global = __webpack_require__(0);
var hide = __webpack_require__(7);
var Iterators = __webpack_require__(14);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(78);
var step = __webpack_require__(79);
var Iterators = __webpack_require__(14);
var toIObject = __webpack_require__(13);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(40)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(16);
var global = __webpack_require__(0);
var ctx = __webpack_require__(17);
var classof = __webpack_require__(47);
var $export = __webpack_require__(6);
var isObject = __webpack_require__(8);
var aFunction = __webpack_require__(18);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var speciesConstructor = __webpack_require__(48);
var task = __webpack_require__(49).set;
var microtask = __webpack_require__(87)();
var newPromiseCapabilityModule = __webpack_require__(32);
var perform = __webpack_require__(50);
var promiseResolve = __webpack_require__(51);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(1)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(88)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(22)($Promise, PROMISE);
__webpack_require__(89)(PROMISE);
Wrapper = __webpack_require__(2)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(90)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(17);
var call = __webpack_require__(83);
var isArrayIter = __webpack_require__(84);
var anObject = __webpack_require__(4);
var toLength = __webpack_require__(45);
var getIterFn = __webpack_require__(85);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(14);
var ITERATOR = __webpack_require__(1)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(47);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(14);
module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var macrotask = __webpack_require__(49).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(15)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(7);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var dP = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(5);
var SPECIES = __webpack_require__(1)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(1)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(6);
var core = __webpack_require__(2);
var global = __webpack_require__(0);
var speciesConstructor = __webpack_require__(48);
var promiseResolve = __webpack_require__(51);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(32);
var perform = __webpack_require__(50);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
var $Object = __webpack_require__(2).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperty: __webpack_require__(3).f });


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TopBar__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StatModel__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_SingletonLoading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_msg_stat__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_tpl_stat__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_service__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_service__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_model__ = __webpack_require__(33);














var StatSimulator = function () {
  function StatSimulator(options) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StatSimulator);

    var _ = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["q" /* not */])(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(options)) throw new Error('StatSimulator constructor require options object');

    _.option = $.extend({
      staticDomain: '',
      apiDomain: __WEBPACK_IMPORTED_MODULE_12__model_model__["a" /* API_DOMAIN_DEFAULT */],
      classId: '0',
      page: 'default', // default, modify, view
      wrap: null,
      data: null,
      classDefaultStatData: null,
      isLogin: false,
      savedUserStatNum: 0,
      useHighlightForDiff: true, // use only in setting qna board
      global: window
    }, options);

    _.model = __WEBPACK_IMPORTED_MODULE_5__StatModel__["a" /* default */].getInstance();

    _.loading = __WEBPACK_IMPORTED_MODULE_6__utils_SingletonLoading__["a" /* default */].getInstance();

    _.wrap = null;

    _.topBar = null;

    _.header = null;

    _.section = null;

    _.data = _.option.data;

    _.statData = null;

    _.statDataFirstAtLevel = null;

    _.defaultStatsForDiff = null; // class lv50 default stat for display diff

    _.consumedPoint = 0;

    _.lastConsumedStatName = '';

    _.isUsedElixirAtCurrentLevel = false;

    _.isCompleteSetBaseStat = false;

    _.global = _.option.global;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StatSimulator, [{
    key: 'init',
    value: function init() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ = this;

      _.wrap = $(_.option.wrap);
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["r" /* notSingleEle */])(_.wrap)) throw new Error('wrap must be single element.');

      console.log('StatSimulator init _.data :', _.option.data);

      switch (_.option.page) {
        case 'default':
          console.log('StatSimulator.init - default page');

          _.statData = __WEBPACK_IMPORTED_MODULE_5__StatModel__["a" /* default */].getDefaultStatData(_.data, { // _.data from getClassDefaultStat function
            'page': _.option.page,
            'type': _.model.DEVICE_TYPE,
            'classType': _.option.classId,
            'level': _.model.LEVEL_INIT,
            'currentLevel': _.model.LEVEL_INIT,
            'targetLevel': _.model.LEVEL_MAX
          });

          _.statDataFirstAtLevel = $.extend({}, _.statData);

          _.defaultStatsForDiff = $.extend({}, _.statData);

          _.isCompleteSetBaseStat = false;

          _.setInstance({ page: 'default' });
          break;

        case 'view':
          console.log('StatSimulator.init - view page');

          _.statData = _.data; // _.data from getSavedStatData function

          _.statDataFirstAtLevel = $.extend({}, _.statData);

          _.defaultStatsForDiff = __WEBPACK_IMPORTED_MODULE_5__StatModel__["a" /* default */].getDefaultStatData(_.option.classDefaultStatData, {
            'page': _.option.page,
            'type': _.model.DEVICE_TYPE,
            'classType': _.option.classId,
            'level': _.model.LEVEL_INIT,
            'currentLevel': _.model.LEVEL_INIT,
            'targetLevel': _.model.LEVEL_MAX
          });

          _.isCompleteSetBaseStat = true;

          _.setInstance({ page: 'view' });
          break;

        case 'modify':
          console.log('StatSimulator.init - modify page');

          _.statData = $.extend(_.data, { 'page': _.option.page }); // _.data from getSavedStatData function of 'view' mode.

          _.statDataFirstAtLevel = $.extend({}, _.statData);

          _.defaultStatsForDiff = __WEBPACK_IMPORTED_MODULE_5__StatModel__["a" /* default */].getDefaultStatData(_.option.classDefaultStatData, {
            'page': _.option.page,
            'type': _.model.DEVICE_TYPE,
            'classType': _.option.classId,
            'level': _.model.LEVEL_INIT,
            'currentLevel': _.model.LEVEL_INIT,
            'targetLevel': _.model.LEVEL_MAX
          });

          _.isCompleteSetBaseStat = true;

          _.setInstance({ page: 'modify' });
          break;
      }

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { page: '' };

      var _ = this;

      // empty previous simulator
      _.destroyContents();

      _.wrap.empty();

      // create new simulator // 2022.01 템플릿
      var contentsTplFunc = doT.template(Object(__WEBPACK_IMPORTED_MODULE_8__model_tpl_stat__["c" /* getStatSimulatorTpl */])()),
          contentsTpl = '',
          changedStats = null;

      switch (obj.page) {
        case 'default':
          console.log('default');

          console.log('=> StatSimulator.js setInstance() _.statData : ', _.statData);

          contentsTpl = contentsTplFunc($.extend(_.statData, {
            page: _.option.page,
            level: _.option.level,
            targetLevel: _.option.targetLevel,
            classImageUrl: _.option.staticDomain + '/resource/lineage/profile/char' + _.option.classId + '_m.png'
          }));

          _.wrap.append(contentsTpl);

          _.topBar = new __WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */]({
            page: _.option.page,
            wrap: $('header', _.wrap)
          }).init();

          _.header = new __WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */]({
            wrap: $('section.char', _.wrap),
            data: _.statData
          }).init();

          _.section = new __WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */]({
            wrap: $('section.variation', _.wrap)
          }).init();

          _.setTopBarEvents(true);
          _.setHeaderEvents(true);
          _.setSectionEvents(true);

          _.changeSectionBtnsStatus();
          break;

        case 'view':
          console.log('view');

          contentsTpl = contentsTplFunc($.extend(_.statData, { page: _.option.page }));
          _.wrap.append(contentsTpl);

          _.topBar = new __WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */]({
            page: _.option.page,
            wrap: $('header', _.wrap)
          }).init();

          _.section = new __WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */]({
            wrap: $('section.variation', _.wrap),
            model: _.model
          }).init();

          _.setTopBarEvents(true);

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.option.useHighlightForDiff)) {
            changedStats = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["e" /* getChangedStats */])(_.defaultStatsForDiff, _.statData);
            _.section.setHighlightChangedStats(changedStats);
          } else {
            // 'no highlight for diff'
          }
          break;

        case 'modify':
          console.log('modify');

          contentsTpl = contentsTplFunc($.extend(_.statData, { page: _.option.page }));
          _.wrap.append(contentsTpl);

          _.topBar = new __WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */]({
            page: _.option.page,
            wrap: $('header', _.wrap)
          }).init();

          _.header = new __WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */]({
            wrap: $('section.char', _.wrap),
            data: _.statData,
            model: _.model
          }).init();

          _.section = new __WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */]({
            wrap: $('section.variation', _.wrap),
            model: _.model
          }).init();

          _.setTopBarEvents(true);
          _.setHeaderEvents(true);
          _.setSectionEvents(true);

          _.changeSectionBtnsStatus();

          changedStats = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["e" /* getChangedStats */])(_.defaultStatsForDiff, _.statData);
          _.section.setHighlightChangedStats(changedStats);
          break;

        case 'reset:modify':
          console.log('reset:modify');

          contentsTpl = contentsTplFunc($.extend(_.statData, {
            page: _.option.page,
            classImageUrl: _.option.staticDomain + '/resource/lineage/profile/char' + _.option.classId + '_m.png'
          }));
          _.wrap.append(contentsTpl);

          _.topBar = new __WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */]({
            page: _.option.page,
            wrap: $('header', _.wrap)
          }).init();

          _.header = new __WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */]({
            wrap: $('section.char', _.wrap),
            data: _.statData,
            model: _.model
          }).init();

          _.section = new __WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */]({
            wrap: $('section.variation', _.wrap),
            model: _.model
          }).init();

          _.setTopBarEvents(true);
          _.setHeaderEvents(true);
          _.setSectionEvents(true);

          _.changeSectionBtnsStatus();
          break;
      }

      _.setLevelUpKeyEvents(_.statData.type);
    }
  }, {
    key: 'switchMode',
    value: function switchMode(prevPage, nextPage) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(prevPage === 'view', nextPage === 'modify')) {
        _.option.page = 'modify';

        _.init();
      }
    }
  }, {
    key: 'setTopBarEvents',
    value: function setTopBarEvents(flag) {
      var _ = this,
          $topBar = $(_.topBar);

      if ($topBar.length <= 0) return;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(flag)) {
        $topBar.on(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_CLOSE, function (evt) {
          $(_).trigger({ type: StatSimulator.EVT_CLOSE });
        });

        $topBar.on(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_SAVE, function (evt) {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.option.isLogin)) {
            _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].CAN_SAVE_STAT_AFTER_LOGIN); // '스탯 세팅 저장은 로그인 후 이용 가능합니다.'
            return;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(_.option.page === 'default', _.option.savedUserStatNum >= _.model.USER_STAT_NUM_LIMIT)) {
            _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].SAVE_STAT_LIMIT); // '스탯 세팅 저장은 계정당 최대 6개까지 가능합니다. 새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요. 스탯 세팅을 계속 진행하시겠습니까?'
            return;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.isEmptyRemainStat())) return;

          var stat = null,
              sendData = null;
          switch (_.option.page) {
            case 'default':
              stat = _.statData;

              sendData = {
                'classId': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.classType),
                'targetLevel': stat.targetLevel,
                'level': stat.level,
                'statMetaInfo': {
                  'hp': stat.HP,
                  'mp': stat.MP,
                  'mainStat': {
                    'STR': stat.STR,
                    'CON': stat.CON,
                    'DEX': stat.DEX,
                    'INT': stat.INT,
                    'WIS': stat.WIS,
                    'CHA': stat.CHA
                  }
                },
                'statPointInfo': {
                  'remainStatPoint': stat.remainStat,
                  'totalStatPoint': stat.remainTotalStat,
                  'remainElixirPoint': stat.elixirStat,
                  'totalElixirPoint': stat.elixirTotalStat,
                  'usedElixir': _.header.isCheckedElixirStatCheckBox()
                }
              };

              console.log('=> StatSimulator.js stat(sendData) : ', stat);

              // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-POST/api/simulator/stat/user
              Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["g" /* saveNewUserStat */])({
                apiDomain: _.option.apiDomain,
                sendData: sendData,
                beforeSend: function beforeSend() {
                  return _.loading.start();
                }

              }).then(function (data, textStatus, jqXHR) {
                console.log('saveNewUserStat - data :', data);

                _.loading.end();

                if (data.result === 'success') {
                  $(_).trigger({ type: StatSimulator.EVT_SAVE_STAT_COMPLETE });
                } else {
                  if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(data))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
                }
              }).catch(function (err) {
                _.loading.end();

                if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
              });
              break;

            case 'modify':
              stat = _.statData;

              sendData = {
                'classId': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.classType),
                'targetLevel': stat.targetLevel,
                'level': stat.level,
                'statMetaInfo': {
                  'hp': stat.HP,
                  'mp': stat.MP,
                  'mainStat': {
                    'STR': stat.STR,
                    'CON': stat.CON,
                    'DEX': stat.DEX,
                    'INT': stat.INT,
                    'WIS': stat.WIS,
                    'CHA': stat.CHA
                  }
                },
                'statPointInfo': {
                  'remainStatPoint': stat.remainStat,
                  'totalStatPoint': stat.remainTotalStat,
                  'remainElixirPoint': stat.elixirStat,
                  'totalElixirPoint': stat.elixirTotalStat,
                  'usedElixir': _.header.isCheckedElixirStatCheckBox()
                }
              };

              // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-PUT/api/simulator/stat/user/:idx
              Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["h" /* saveUserStat */])({
                apiDomain: _.option.apiDomain,
                idx: _.data.idx,
                sendData: sendData,
                beforeSend: function beforeSend() {
                  return _.loading.start();
                }

              }).then(function (data, textStatus, jqXHR) {
                console.log('saveUserStat - data :', data);

                _.loading.end();

                if (data.result === 'success') {
                  $(_).trigger({ type: StatSimulator.EVT_SAVE_STAT_COMPLETE });
                } else {
                  if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(data))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
                }
              }).catch(function (err) {
                _.loading.end();

                if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
              });

              break;
          }
        });

        $topBar.on(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_TRY_RESET, function (evt) {
          console.log('TopBar.EVT_TRY_RESET');
          // none
        });

        $topBar.on(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_RESET, function (evt) {
          console.log('TopBar.EVT_RESET');

          _.resetDefaultStat();
        });

        $topBar.on(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_MODIFY, function (evt) {
          console.log('TopBar.EVT_MODIFY');

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.option.isLogin)) {
            _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].CAN_MODIFY_STAT_AFTER_LOGIN); // '스탯 세팅 수정은 로그인 후 이용 가능합니다.'
            return;
          }

          _.switchMode(_.option.page, 'modify');
        });

        $topBar.on(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_DELETE, function (evt) {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["o" /* isString */])(_.statData.idx), _.statData.idx !== '')) {
            var msg = __WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].TRY_DELETE_STAT({ level: _.statData.level });

            var isConfirmDeleteStat = _.global.confirm(msg); // ${0}Lv 스탯 세팅을 삭제하시겠습니까?
            if (isConfirmDeleteStat) _.callDeleteApi(_.statData.idx);
          }
        });
      } else {
        $topBar.off(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_CLOSE).off(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_SAVE).off(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_TRY_RESET).off(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_RESET).off(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_MODIFY).off(__WEBPACK_IMPORTED_MODULE_2__TopBar__["a" /* default */].EVT_DELETE);
      }
    }
  }, {
    key: 'resetDefaultStat',
    value: function resetDefaultStat() {
      var _ = this;

      switch (_.option.page) {
        case 'default':
          _.statData = $.extend({}, _.defaultStatsForDiff);
          _.statDataFirstAtLevel = $.extend({}, _.statData);

          _.isCompleteSetBaseStat = false;

          _.setInstance({ page: 'default' });
          break;

        case 'modify':
          console.log('modify');

          _.data = $.extend(_.statData, _.defaultStatsForDiff);
          _.statData = $.extend({}, _.data);
          _.statDataFirstAtLevel = $.extend({}, _.statData);

          _.defaultStatsForDiff = $.extend({}, _.statData);

          _.isCompleteSetBaseStat = false;

          _.setInstance({ page: 'reset:modify' });
          break;
      }
    }
  }, {
    key: 'callDeleteApi',
    value: function callDeleteApi(idx) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.option.isLogin)) {
        _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].CAN_DELETE_STAT_AFTER_LOGIN); // '스탯 세팅 삭제는 로그인 후 이용 가능합니다.'
        return;
      }

      // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-DELETE/api/simulator/stat/user/:idx
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["c" /* deleteUserStat */])({
        apiDomain: _.option.apiDomain,
        idx: idx,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        console.log('deleteUserStat - data :', data);

        _.loading.end();

        if (data.result === 'success') {
          $(_).trigger({ type: StatSimulator.EVT_DELETE_STAT_COMPLETE });
        } else {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(data))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
        }
      }).catch(function (err) {
        _.loading.end();

        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'setHeaderEvents',
    value: function setHeaderEvents(flag) {
      var _ = this,
          $header = $(_.header);

      if ($header.length <= 0) return;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(flag)) {
        $header.on(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */].EVT_LEVEL_UP, function (evt) {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.header.isUsableLevelUpBtn()), Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading))) return;

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.isCompleteSetBaseStat)) {
            // 2022.01
            _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].CAN_LEVELUP_AFTER_INIT_BASE_STAT); // '베이스 스탯 포인트 분배 후에 레벨업하실 수 있습니다.'
            return;
          }

          if (_.statData.remainStat > 0) {
            _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].CAN_LEVELUP_AFTER_EXHAUST_REMAIN_STAT); // '남은 스탯을 모두 사용하셔야 레벨업하실 수 있습니다.'
            return;
          }
          if (_.statData.level >= _.statData.targetLevel) {
            _.global.alert("목표 레벨까지 모두 레벨업하셨습니다."); // 2022.01
            // _.global.alert(ALERT.CAN_LEVELUP_AFTER_EXHAUST_REMAIN_STAT); // '남은 스탯을 모두 사용하셔야 레벨업하실 수 있습니다.'
            return;
          }

          var sendData = {
            'classId': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId),
            'level': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.level),
            'targetLevel': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.targetLevel),
            'hp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(_.statData.HP),
            'mp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(_.statData.MP),
            'currentStat': {
              'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.STR),
              'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.INT),
              'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.DEX),
              'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.WIS),
              'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.CON),
              'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.CHA)
            }
          };

          _.callCalculateApiByLevelUp(sendData);
        });

        $header.on(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */].EVT_CHECK_ELIXIR_CHECKBOX, function (evt) {
          console.log('EVT_CHECK_ELIXIR_CHECKBOX');

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.header.isCheckedElixirStatCheckBox())) {

            if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.isUsedElixirAtCurrentLevel), _.statData.elixirStat > 0)) {
              _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].CAN_PROCESS_AFTER_EXHAUST_ELIXIR_STAT); // '엘릭서의 스탯을 모두 사용하셔야 다음 진행을 하실 수 있습니다.'

              _.header.setElixirStatCheckBoxChecked(true);
              _.statData.elixirUseYN = true;
            } else {
              _.header.activateElixirStatField(false);

              _.statData.elixirUseYN = false;
            }
          } else {
            _.statData.elixirUseYN = true;
          }

          _.changeSectionBtnsStatus();
        });
      } else {

        $header.off(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */].EVT_LEVEL_UP).off(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */].EVT_CHECK_ELIXIR_CHECKBOX);
      }
    }
  }, {
    key: 'callCalculateApi',
    value: function callCalculateApi(options) {
      // plus : { type, pointType, sendData, consumeStatName }
      // minus : { type, pointType, sendData }

      var _ = this,
          opt = _.option,
          model = _.model;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* calculateStat */])({
        apiDomain: opt.apiDomain,
        classId: opt.classId,
        sendData: options.sendData,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        console.log('calculateStat - data :', data);

        _.loading.end();

        var sub = data.formattedSubStat,
            attribute = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(data), Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(sub)) ? sub.attribute : null;

        var receivedStats = null,
            changedStats = null;

        switch (options.type) {
          case 'plus':
            if (options.pointType === 'remainStat') {
              _.statData.remainStat--;
            } else if (options.pointType === 'elixirStat') {
              _.statData.elixirStat--;
            }

            receivedStats = {
              'type': model.DEVICE_TYPE,
              'classType': _.option.classId,

              // 'point' : (data) ? getDefined(data.remainStat, '0') : '-',
              'level': _.statData.level,
              'targetLevel': _.statData.targetLevel,

              'HP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.hp, '0'),
              'MP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mp, '0'),

              'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.STR, 0)),
              'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.DEX, 0)),
              'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.INT, 0)),
              'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CON, 0)),
              'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.WIS, 0)),
              'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CHA, 0)),

              // STR
              'DAMAGE_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.damageShort, '0'),
              'HIT_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.hitShort, '0'),
              'FATAL_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.fatalShort, '0'),
              'WEIGHT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.weight, '0'),

              // INT
              'DAMAGE_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.damageWiz, '0'),
              'HIT_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.hitWiz, '0'),
              'FATAL_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.fatalWiz, '0'),
              'MB': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mb, '0'),
              'MP_MINUS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mpMinus, '0'),

              // DEX
              'DAMAGE_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.damageLong, '0'),
              'HIT_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.hitLong, '0'),
              'FATAL_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.fatalLong, '0'),
              'AC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.ac, '0'),
              'ER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.er, '0'),

              // WIS
              'LEVELUP_MP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.min, '0'),
              'LEVELUP_MP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.max, '0'),
              'MP_RECOVER_TIC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverTic, '0'),
              'MP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverLiquor, '0'),
              'MR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mr, '0'),

              // CON
              'LEVELUP_HP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.min, '0'),
              'LEVELUP_HP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.max, '0'),
              'HP_RECOVER_TIC_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.min, '0'),
              'HP_RECOVER_TIC_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.max, '0'),
              'HP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverLiquor, '0'),
              // CON WEIGHT === STR WEIGHT

              // CHA  // 20211206
              'CHA_HIT_SIKII': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSkill, '0'),
              'CHA_HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSummon, '0'),
              'CHA_HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitDragon, '0'),
              'CHA_HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitFear, '0'),
              'CHA_SKILL_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.skillTimeReduction, '0'),
              'CHA_STATUS_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.statusTimeReduction, '0'),

              // attribute
              'FIRE': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.fire, '0') : '0',
              'WATER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.water, '0') : '0',
              'STORM': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.storm, '0') : '0',
              'LAND': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.land, '0') : '0',
              'HIT_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSkill, '0') : '0',
              'RES_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSkill, '0') : '0',
              'HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSummon, '0') : '0',
              'RES_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSummon, '0') : '0',
              'HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitDragon, '0') : '0',
              'RES_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resDragon, '0') : '0',
              'HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitFear, '0') : '0',
              'RES_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resFear, '0') : '0',

              'remainStat': _.statData.remainStat,
              'remainTotalStat': _.statData.remainTotalStat,
              'elixirStat': _.statData.elixirStat,
              'elixirTotalStat': _.statData.elixirTotalStat,

              'elixirUseYN': _.header.isCheckedElixirStatCheckBox() // elixir stat checkbox checked: true or false
            };

            changedStats = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["e" /* getChangedStats */])(_.statDataFirstAtLevel, receivedStats);

            if (options.pointType === 'remainStat') {
              _.header.setRemainStat(receivedStats.remainStat);
            } else if (options.pointType === 'elixirStat') {
              _.header.setElixirStat(receivedStats.elixirStat);

              _.isUsedElixirAtCurrentLevel = true;
            }

            _.header.setHpMp(changedStats);

            _.section.setChangedStat(_.isCompleteSetBaseStat, changedStats, receivedStats);
            _.section.setStatValueColor(_.statData.level);

            _.statData = receivedStats;

            _.consumedPoint++;

            _.lastConsumedStatName = options.consumeStatName || '';

            break;

          case 'minus':
            _.statData.remainStat++;

            receivedStats = {
              'type': model.DEVICE_TYPE,
              'classType': _.option.classId,

              // 'point' : getDefined(data.remainStat, '0'),
              'level': _.statData.level,
              'targetLevel': _.statData.targetLevel,

              'HP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.hp, '0'),
              'MP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mp, '0'),

              'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.STR, '0')),
              'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.DEX, '0')),
              'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.INT, '0')),
              'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CON, '0')),
              'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.WIS, '0')),
              'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CHA, '0')),

              // STR
              'DAMAGE_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.damageShort, '0'),
              'HIT_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.hitShort, '0'),
              'FATAL_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.fatalShort, '0'),
              'WEIGHT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.weight, '0'),

              // INT
              'DAMAGE_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.damageWiz, '0'),
              'HIT_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.hitWiz, '0'),
              'FATAL_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.fatalWiz, '0'),
              'MB': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mb, '0'),
              'MP_MINUS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mpMinus, '0'),

              // DEX
              'DAMAGE_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.damageLong, '0'),
              'HIT_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.hitLong, '0'),
              'FATAL_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.fatalLong, '0'),
              'AC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.ac, '0'),
              'ER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.er, '0'),

              // WIS
              'LEVELUP_MP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.min, '0'),
              'LEVELUP_MP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.max, '0'),
              'MP_RECOVER_TIC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverTic, '0'),
              'MP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverLiquor, '0'),
              'MR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mr, '0'),

              // CON
              'LEVELUP_HP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.min, '0'),
              'LEVELUP_HP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.max, '0'),
              'HP_RECOVER_TIC_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.min, '0'),
              'HP_RECOVER_TIC_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.max, '0'),
              'HP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverLiquor, '0'),
              // CON WEIGHT === STR WEIGHT

              // CHA  // 20211206
              'CHA_HIT_SIKII': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSkill, '0'),
              'CHA_HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSummon, '0'),
              'CHA_HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitDragon, '0'),
              'CHA_HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitFear, '0'),
              'CHA_SKILL_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.skillTimeReduction, '0'),
              'CHA_STATUS_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.statusTimeReduction, '0'),

              // attribute
              'FIRE': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.fire, '0') : '0',
              'WATER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.water, '0') : '0',
              'STORM': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.storm, '0') : '0',
              'LAND': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.land, '0') : '0',
              'HIT_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSkill, '0') : '0',
              'RES_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSkill, '0') : '0',
              'HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSummon, '0') : '0',
              'RES_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSummon, '0') : '0',
              'HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitDragon, '0') : '0',
              'RES_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resDragon, '0') : '0',
              'HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitFear, '0') : '0',
              'RES_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resFear, '0') : '0',

              'remainStat': _.statData.remainStat,
              'remainTotalStat': _.statData.remainTotalStat,
              'elixirStat': _.statData.elixirStat,
              'elixirTotalStat': _.statData.elixirTotalStat,

              'elixirUseYN': _.header.isCheckedElixirStatCheckBox()
            };

            console.log('receivedStats :', receivedStats);

            changedStats = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["e" /* getChangedStats */])(_.statData, receivedStats);
            console.log('minus - changedStat :', changedStats);

            _.header.setRemainStat(receivedStats.remainStat);
            _.header.setHpMp(changedStats);

            _.section.setChangedStat(_.isCompleteSetBaseStat, changedStats, receivedStats, _.statDataFirstAtLevel, _.defaultStatsForDiff);
            _.section.setStatValueColor(_.statData.level);

            _.statData = receivedStats;
            _.consumedPoint--;

            break;
        }

        if (_.statData.remainStat > 0 && _.statData.level < _.statData.targetLevel) {
          // 2022.01 targetLevel
          console.log("=> StatSimulator.js  if(.statData.remainStat > 0 &&_.statData.level < _.statData.targetLevel )  ");
          _.header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);
        } else {
          console.log('callCalculateApi remain stat is 0');

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.isCompleteSetBaseStat) && _.statData.targetLevel > 50) {
            console.log('show _confirmBaseStatModal');

            window.setTimeout(function () {
              _.confirmDistributeBaseStat();
            }, 50);
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.header.isCheckedElixirStatCheckBox())) {
            console.log('checkbox not checked');
          } else {
            console.log('checkbox checked');

            if (_.statData.elixirStat <= 0) {
              console.log('checkbox checked. elixir is 0.');

              if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.isCompleteSetBaseStat) && _.statData.targetLevel > 50) {
                console.log('show _confirmBaseStatModal');

                window.setTimeout(function () {
                  _.confirmDistributeBaseStat();
                }, 50);
              } else {
                console.log('_.isCompleteSetBaseStat is true');
              }
            } else {
              console.log('-checkbox checked. elixir > 0.');

              if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["l" /* isLevelCanConsumeElixirStat */])(parseInt(_.statData.level - model.LEVEL_INIT)))) {
                // 2019.11
                console.log('can not consume elixir at ' + _.statData.level + ' level');
                _.header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
              } else {
                console.log('can consume elixir at ' + _.statData.level + ' level');
              }
            }
          }
        }

        _.changeSectionBtnsStatus();

        _.header.setHpMp(_.statData);

        _.focusWrap(_.statData.type);
      }).catch(function (err) {
        console.log('calculateStat - error :', err);

        _.loading.end();

        _.focusWrap(_.statData.type);

        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_CALCULATE_STAT); // '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'callCalculateApiByConfirmBaseStat',
    value: function callCalculateApiByConfirmBaseStat(sendData) {
      console.log('callCalculateApiByConfirmBaseStat sendData :', sendData);

      var _ = this,
          opt = _.option,
          header = _.header,
          section = _.section;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["a" /* calculateStat */])({
        apiDomain: opt.apiDomain,
        classId: opt.classId,
        sendData: sendData,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        console.log('callCalculateApiByConfirmBaseStat() - data :', data);

        _.loading.end();

        var sub = data.formattedSubStat,
            attribute = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(data), Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(sub)) ? sub.attribute : null;

        var receivedStats = {
          'page': _.option.page,

          'type': _.model.DEVICE_TYPE,
          'classType': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(sendData.classId),

          'level': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(sendData.level),
          'targetLevel': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(sendData.targetLevel),

          'HP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.hp, '0'),
          'MP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mp, '0'),

          'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.STR, '0')),
          'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.DEX, '0')),
          'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.INT, '0')),
          'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CON, '0')),
          'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.WIS, '0')),
          'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CHA, '0')),

          // STR
          'DAMAGE_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.damageShort, '0'),
          'HIT_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.hitShort, '0'),
          'FATAL_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.fatalShort, '0'),
          'WEIGHT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.weight, '0'),

          // INT
          'DAMAGE_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.damageWiz, '0'),
          'HIT_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.hitWiz, '0'),
          'FATAL_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.fatalWiz, '0'),
          'MB': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mb, '0'),
          'MP_MINUS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mpMinus, '0'),

          // DEX
          'DAMAGE_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.damageLong, '0'),
          'HIT_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.hitLong, '0'),
          'FATAL_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.fatalLong, '0'),
          'AC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.ac, '0'),
          'ER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.er, '0'),

          // WIS
          'LEVELUP_MP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.min, '0'),
          'LEVELUP_MP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.max, '0'),
          'MP_RECOVER_TIC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverTic, '0'),
          'MP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverLiquor, '0'),
          'MR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mr, '0'),

          // CON
          'LEVELUP_HP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.min, '0'),
          'LEVELUP_HP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.max, '0'),
          'HP_RECOVER_TIC_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.min, '0'),
          'HP_RECOVER_TIC_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.max, '0'),
          'HP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverLiquor, '0'),
          // CON WEIGHT === STR WEIGHT

          // CHA  // 20211206
          'CHA_HIT_SIKII': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSkill, '0'),
          'CHA_HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSummon, '0'),
          'CHA_HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitDragon, '0'),
          'CHA_HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitFear, '0'),
          'CHA_SKILL_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.skillTimeReduction, '0'),
          'CHA_STATUS_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.statusTimeReduction, '0'),

          // attribute
          'FIRE': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.fire, '0') : '0',
          'WATER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.water, '0') : '0',
          'STORM': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.storm, '0') : '0',
          'LAND': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.land, '0') : '0',
          'HIT_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSkill, '0') : '0',
          'RES_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSkill, '0') : '0',
          'HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSummon, '0') : '0',
          'RES_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSummon, '0') : '0',
          'HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitDragon, '0') : '0',
          'RES_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resDragon, '0') : '0',
          'HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitFear, '0') : '0',
          'RES_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resFear, '0') : '0',

          'remainStat': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.remainStat),
          'remainTotalStat': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.remainTotalStat),
          'elixirStat': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.elixirStat),
          'elixirTotalStat': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.elixirTotalStat),

          'elixirUseYN': header.isCheckedElixirStatCheckBox()
        };

        _.statData = receivedStats;
        _.statDataFirstAtLevel = $.extend({}, _.statData);

        _.consumedPoint = 0;

        _.isCompleteSetBaseStat = true;

        console.log('_callCalculateApiByConfirmBaseStat receivedStats :', receivedStats);

        header.setLevel(receivedStats.level);
        header.setRemainStat(receivedStats.remainStat);
        header.setRemainTotalStat(receivedStats.remainTotalStat);
        header.setElixirStat(receivedStats.elixirStat);
        header.setElixirTotalStat(receivedStats.elixirTotalStat);
        header.setHpMp(receivedStats);

        section.reset(receivedStats);

        _.changeSectionBtnsStatus();

        var changedStats = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["e" /* getChangedStats */])(_.statData, _.defaultStatsForDiff);
        section.setHighlightChangedStats(changedStats); // add '.on' class to changed stats
        section.setStatValueColor(_.statData.level); // STR, INT, DEX, WIS, CON, CHA

        _.focusWrap(_.statData.type);
      }).catch(function (err) {
        console.log('callCalculateApiByConfirmBaseStat() - error :', err);

        _.loading.end();

        _.focusWrap(_.statData.type);

        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_CALCULATE_STAT); // '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'callCalculateApiByLevelUp',
    value: function callCalculateApiByLevelUp(sendData) {
      var _ = this,
          statData = _.statData;

      console.log('callCalculateApiByLevelUp - statData :', statData);

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_service__["b" /* calculateStatByLevelUp */])({
        apiDomain: _.option.apiDomain,
        classId: _.option.classId,
        level: statData.level + 1,
        targetLevel: _.option.targetLevel,
        sendData: sendData,
        beforeSend: function beforeSend() {
          return _.loading.start();
        }

      }).then(function (data, textStatus, jqXHR) {
        console.log('calculateStatByLevelUp - data :', data);

        _.loading.end();

        var sub = data.formattedSubStat,
            attribute = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(data), Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(sub)) ? sub.attribute : null,
            receivedStats = {
          'page': _.option.page,

          'type': _.model.DEVICE_TYPE,
          'classType': _.option.classId,

          'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.STR, '0')),
          'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.DEX, '0')),
          'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.INT, '0')),
          'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CON, '0')),
          'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.WIS, '0')),
          'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mainStat.CHA, '0')),

          // 'point' : getDefined(data.remainStat, '0'),
          'level': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(data.level),
          'targetLevel': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(data.targetLevel),
          'HP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.hp, '0'),
          'MP': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(data.mp, '0'),

          // STR
          'DAMAGE_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.damageShort, '0'),
          'HIT_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.hitShort, '0'),
          'FATAL_SHORT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.fatalShort, '0'),
          'WEIGHT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.STR.weight, '0'),

          // INT
          'DAMAGE_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.damageWiz, '0'),
          'HIT_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.hitWiz, '0'),
          'FATAL_WIZ': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.fatalWiz, '0'),
          'MB': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mb, '0'),
          'MP_MINUS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.INT.mpMinus, '0'),

          // DEX
          'DAMAGE_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.damageLong, '0'),
          'HIT_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.hitLong, '0'),
          'FATAL_LONG': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.fatalLong, '0'),
          'AC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.ac, '0'),
          'ER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.DEX.er, '0'),

          // WIS
          'LEVELUP_MP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.min, '0'),
          'LEVELUP_MP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.levelupMpPlus.max, '0'),
          'MP_RECOVER_TIC': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverTic, '0'),
          'MP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mpRecoverLiquor, '0'),
          'MR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.WIS.mr, '0'),

          // CON
          'LEVELUP_HP_PLUS_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.min, '0'),
          'LEVELUP_HP_PLUS_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpPlus.max, '0'),
          'HP_RECOVER_TIC_MIN': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.min, '0'),
          'HP_RECOVER_TIC_MAX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverTic.max, '0'),
          'HP_RECOVER_LIQUOR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CON.hpRecoverLiquor, '0'),
          // CON WEIGHT === STR WEIGHT

          // CHA  // 20211206
          'CHA_HIT_SIKII': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSkill, '0'),
          'CHA_HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitSummon, '0'),
          'CHA_HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitDragon, '0'),
          'CHA_HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.hitFear, '0'),
          'CHA_SKILL_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.skillTimeReduction, '0'),
          'CHA_STATUS_TIME_REDUCTION': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(sub.CHA.statusTimeReduction, '0'),

          // attribute
          'FIRE': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.fire, '0') : '0',
          'WATER': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.water, '0') : '0',
          'STORM': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.storm, '0') : '0',
          'LAND': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.land, '0') : '0',
          'HIT_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSkill, '0') : '0',
          'RES_SKILL': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSkill, '0') : '0',
          'HIT_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitSummon, '0') : '0',
          'RES_SUMMON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resSummon, '0') : '0',
          'HIT_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitDragon, '0') : '0',
          'RES_DRAGON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resDragon, '0') : '0',
          'HIT_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.hitFear, '0') : '0',
          'RES_FEAR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(attribute) ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["f" /* getDefined */])(attribute.resFear, '0') : '0',

          'remainStat': statData.remainStat + 1,
          'remainTotalStat': statData.remainTotalStat + 1,
          'elixirStat': statData.elixirStat,
          'elixirTotalStat': statData.elixirTotalStat,

          'elixirUseYN': _.header.isCheckedElixirStatCheckBox()
        };

        console.log('receivedStats :', receivedStats);

        /* 2019.11
        if (isLevelCanConsumeElixirStat( parseInt(receivedStats.level - _.model.LEVEL_INIT), _.model.PER_LEVEL_PLUS_ELIXIR_POINT)) {
          receivedStats.elixirStat++;
          receivedStats.elixirTotalStat++;
        } */

        /* 2021.12 ~ 2022.01 */
        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["l" /* isLevelCanConsumeElixirStat */])(parseInt(receivedStats.level - _.model.LEVEL_INIT))) {
          var _getPlusElixirPoint = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["g" /* getPlusElixirPointByLevel */])(parseInt(receivedStats.level), parseInt(_.model.LEVEL_INIT), _.model.PLUS_ELIXIR_POINT_BY_LEVEL);
          console.log('# _getPlusElixirPoint : ', _getPlusElixirPoint);
          receivedStats.elixirStat = receivedStats.elixirStat + _getPlusElixirPoint;
          receivedStats.elixirTotalStat = receivedStats.elixirTotalStat + _getPlusElixirPoint;
        }

        if (receivedStats.level > _.model.LEVEL_USABLE_ELIXIR_POINT) {
          // 100
          return;
          // receivedStats.elixirStat = 0;
          // receivedStats.elixirTotalStat = 0;
        }

        _.header.setRemainStat(receivedStats.remainStat);
        _.header.setRemainTotalStat(receivedStats.remainTotalStat);
        _.header.setElixirStat(receivedStats.elixirStat);
        _.header.setElixirTotalStat(receivedStats.elixirTotalStat);
        _.header.setLevel(receivedStats.level);
        _.header.setHpMp(receivedStats);
        _.header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);

        _.section.reset(receivedStats);

        _.statData = receivedStats;
        _.statDataFirstAtLevel = $.extend({}, _.statData);
        _.consumedPoint = 0;

        _.isUsedElixirAtCurrentLevel = false;

        _.changeSectionBtnsStatus();

        var changedStats = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["e" /* getChangedStats */])(_.statData, _.defaultStatsForDiff);
        _.section.setHighlightChangedStats(changedStats); // add '.on' class to changed stats
        _.section.setStatValueColor(_.statData.level); // STR, INT, DEX, WIS, CON, CHA

        _.focusWrap(_.statData.type);
      }).catch(function (err) {
        console.log('calculateStatByLevelUp - error :', err);

        _.loading.end();

        _.focusWrap(_.statData.type);

        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_service__["a" /* handleApiError */])(err.jqXHR))) _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].FAIL_CALCULATE_STAT); // '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    }
  }, {
    key: 'confirmDistributeBaseStat',
    value: function confirmDistributeBaseStat() {
      var _ = this;

      console.log('set confirm base stat modal');

      var isConfirmDistributeBaseStat = _.global.confirm(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].COMPLETE_DISTRIBUTE_BASE_STAT); // 베이스 스탯을 모두 분배하셨습니다. 이제 레벨업으로 원하는 스탯에 보너스 스탯 포인트를 분배하실 수 있습니다.

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(isConfirmDistributeBaseStat)) {
        _.callCalculateApiByConfirmBaseStat({
          'classId': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId),
          'level': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.level),
          'targetLevel': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.targetLevel),
          'hp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.HP),
          'mp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.MP),
          'currentStat': {
            'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.STR),
            'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.INT),
            'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.DEX),
            'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.WIS),
            'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.CON),
            'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.CHA)
          },
          'differenceStat': { 'STR': 0, 'INT': 0, 'DEX': 0, 'WIS': 0, 'CON': 0, 'CHA': 0 },
          'completeBaseStat': true
        });
      } else {
        _.isCompleteSetBaseStat = false;

        _.header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);

        if (_.lastConsumedStatName !== '') _.minusStat(_.lastConsumedStatName);
      }
    }
  }, {
    key: 'setSectionEvents',
    value: function setSectionEvents(flag) {
      var _ = this,
          $section = $(_.section);

      if ($section.length <= 0) return;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(flag)) {
        $section.on(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */].EVT_PLUS_STAT, function (evt) {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

          _.plusStat(evt.statName);
        });

        $section.on(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */].EVT_MINUS_STAT, function (evt) {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.loading.isLoading)) return;

          _.minusStat(evt.statName);
        });
      } else {
        $section.off(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */].EVT_PLUS_STAT).off(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */].EVT_MINUS_STAT);
      }
    }
  }, {
    key: 'plusStat',
    value: function plusStat(statName) {
      var _ = this;

      var stats = _.statData,
          sendData = {
        'classId': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId),
        'level': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.level),
        'targetLevel': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.targetLevel),
        'hp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(stats.HP),
        'mp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(stats.MP),
        'currentStat': {
          'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.STR),
          'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.CON),
          'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.DEX),
          'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.INT),
          'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.WIS),
          'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stats.CHA)
        },
        'differenceStat': {
          'STR': statName === 'STR' ? 1 : 0,
          'INT': statName === 'INT' ? 1 : 0,
          'DEX': statName === 'DEX' ? 1 : 0,
          'WIS': statName === 'WIS' ? 1 : 0,
          'CON': statName === 'CON' ? 1 : 0,
          'CHA': statName === 'CHA' ? 1 : 0
        },
        'completeBaseStat': false
      };

      if (_.statData.remainStat > 0) {
        console.log('remainStat > 0');

        _.callCalculateApi({
          type: 'plus',
          pointType: 'remainStat',
          sendData: sendData,
          consumeStatName: statName
        });
      } else {
        console.log('remainStat <= 0');

        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(_.header.isCheckedElixirStatCheckBox())) {
          // can not use elixir point
          _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].REMAIN_STAT_ZERO); // '사용하실 수 있는 스탯 포인트를 모두 사용하셨습니다.'
        } else {
          // can use elixir point
          if (_.statData.elixirStat <= 0) {
            _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].REMAIN_STAT_ZERO); // '사용하실 수 있는 스탯 포인트를 모두 사용하셨습니다.'
          } else {
            if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["l" /* isLevelCanConsumeElixirStat */])(parseInt(stats.level - _.model.LEVEL_INIT)))) {
              // 2019.11
              _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].IMPOSSIBLE_LEVEL_CONSUME_ELIXIR_STAT); // '엘릭서 스탯 포인트를 사용할 수 없는 레벨입니다.'

              return;
            }

            _.callCalculateApi({
              type: 'plus',
              pointType: 'elixirStat',
              sendData: sendData,
              consumeStatName: statName
            });
          }
        }
      }
    }
  }, {
    key: 'minusStat',
    value: function minusStat(statName) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["q" /* not */])(__WEBPACK_IMPORTED_MODULE_10__utils_util__["o" /* isString */])(statName)) throw new Error('statName parameter type must be String.');

      if (_.consumedPoint <= 0) {
        _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].NO_UNDO_STAT); // '되돌릴 수 있는 스탯 포인트가 없습니다.'
        return;
      }

      var stat = _.statData,
          sendData = {
        'classId': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId),
        'level': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.level),
        'targetLevel': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.targetLevel),
        'hp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(stat.HP),
        'mp': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(stat.MP),
        'currentStat': {
          'STR': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.STR),
          'CON': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.CON),
          'DEX': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.DEX),
          'INT': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.INT),
          'WIS': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.WIS),
          'CHA': Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(stat.CHA)
        },
        'differenceStat': {
          'STR': statName === 'STR' ? -1 : 0,
          'INT': statName === 'INT' ? -1 : 0,
          'DEX': statName === 'DEX' ? -1 : 0,
          'WIS': statName === 'WIS' ? -1 : 0,
          'CON': statName === 'CON' ? -1 : 0,
          'CHA': statName === 'CHA' ? -1 : 0
        },
        'completeBaseStat': false
      };

      _.callCalculateApi({
        type: 'minus',
        pointType: 'remainStat',
        sendData: sendData
      });
    }
  }, {
    key: 'changeSectionBtnsStatus',
    value: function changeSectionBtnsStatus() {
      var _ = this,
          header = _.header,
          section = _.section,
          statFirst = _.statDataFirstAtLevel;

      section.activateAllMinusBtns(false);
      section.activateAllPlusBtns(false);

      var remainStat = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(_.statData.remainStat),
          elixirStat = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["t" /* parseStrIntToInt */])(_.statData.elixirStat);

      var isRemainLevel = _.statData.level <= _.statData.targetLevel; // 2022.01
      // if (_.statData.level >= _.model.targetLevel) header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);  // 2022.01 targetLevel
      console.log('=> StatSimulator.js changeSectionBtnsStatus() _.statData.level >= _.statData.targetLevel', _.statData.level >= _.statData.targetLevel);

      if (remainStat > 0) {
        console.log('remain stat point > 0');

        section.activateAllPlusBtns(true);

        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(header.isCheckedElixirStatCheckBox())) {
          console.log('checkbox not checked');
          header.activateElixirStatField(false);
        } else {
          console.log('checkbox checked');

          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["l" /* isLevelCanConsumeElixirStat */])(parseInt(_.statData.level - _.model.LEVEL_INIT)))) {
            // 2019.11
            console.log('can not consume elixir at ' + _.statData.level + ' level');
            header.activateElixirStatField(false);
          } else {
            console.log('can consume elixir at ' + _.statData.level + ' level');
            header.activateElixirStatField(true);
          }
        }
      } else {
        console.log('remain stat point <= 0');

        if (isNaN(remainStat)) {
          header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);
        } else {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(header.isCheckedElixirStatCheckBox())) {
            console.log('checkbox not checked');

            header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
            header.activateElixirStatField(false);
          } else {
            if (_.statData.elixirStat <= 0) {
              console.log('checkbox checked. elixir is 0.');

              header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
              header.activateElixirStatField(false);
            } else {
              console.log('checkbox checked. elixir > 0.');

              if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["l" /* isLevelCanConsumeElixirStat */])(parseInt(_.statData.level - _.model.LEVEL_INIT)))) {
                // 2019.11
                console.log('can not consume elixir at ' + _.statData.level + ' level');
                header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
                header.activateElixirStatField(false);
              } else {
                console.log('can consume elixir at ' + _.statData.level + ' level');

                header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);
                header.activateElixirStatField(true);

                section.activateAllPlusBtns(true);
              }
            }
          }
        }
      }

      if (elixirStat <= 0) _.header.activateElixirStatField(false);

      var str = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.STR),
          dex = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.DEX),
          int = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.INT),
          con = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.CON),
          wis = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.WIS),
          cha = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.statData.CHA);

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(statFirst.STR) < str) section.activateMinusBtn('STR', true);
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(statFirst.DEX) < dex) section.activateMinusBtn('DEX', true);
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(statFirst.INT) < int) section.activateMinusBtn('INT', true);
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(statFirst.CON) < con) section.activateMinusBtn('CON', true);
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(statFirst.WIS) < wis) section.activateMinusBtn('WIS', true);
      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(statFirst.CHA) < cha) section.activateMinusBtn('CHA', true);

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["u" /* truthy */])(_.isCompleteSetBaseStat)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(header.isCheckedElixirStatCheckBox())) {
          console.log('checkbox not checked');
        } else {
          console.log('checkbox checked');

          if (_.statData.elixirStat <= 0) {
            console.log('checkbox checked. elixir is 0.');
          } else {
            console.log('checkbox checked. elixir > 0.');

            if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["d" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["l" /* isLevelCanConsumeElixirStat */])(parseInt(_.statData.level - _.model.LEVEL_INIT)))) {
              // 2019.11
              console.log('can not consume elixir at ' + _.statData.level + ' level');
            } else {
              console.log('can consume elixir at ' + _.statData.level + ' level');
              section.activateAllPlusBtns(true);
            }
          }
        }
      } else {

        /* 초기 스탯 최대값 셋팅 업데이트 CSDT-547 20210512 */

        var STAT_MAX_AT_LEVEL_INIT_STR = _.model.STAT_MAX_AT_LEVEL_INIT,
            STAT_MAX_AT_LEVEL_INIT_DEX = _.model.STAT_MAX_AT_LEVEL_INIT,
            STAT_MAX_AT_LEVEL_INIT_INT = _.model.STAT_MAX_AT_LEVEL_INIT,
            STAT_MAX_AT_LEVEL_INIT_CON = _.model.STAT_MAX_AT_LEVEL_INIT,
            STAT_MAX_AT_LEVEL_INIT_WIS = _.model.STAT_MAX_AT_LEVEL_INIT,
            STAT_MAX_AT_LEVEL_INIT_CHA = _.model.STAT_MAX_AT_LEVEL_INIT;

        STAT_MAX_AT_LEVEL_INIT_DEX = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId) == 4 ? _.model.STAT_MAX_AT_LEVEL_INIT_DEX_4 : Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId) == 0 ? _.model.STAT_MAX_AT_LEVEL_INIT_DEX_0 : STAT_MAX_AT_LEVEL_INIT_DEX;
        STAT_MAX_AT_LEVEL_INIT_INT = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId) == 4 ? _.model.STAT_MAX_AT_LEVEL_INIT_INT_4 : Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId) == 0 ? _.model.STAT_MAX_AT_LEVEL_INIT_INT_0 : STAT_MAX_AT_LEVEL_INIT_INT;
        STAT_MAX_AT_LEVEL_INIT_WIS = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["s" /* parseInt10 */])(_.option.classId) == 4 ? _.model.STAT_MAX_AT_LEVEL_INIT_WIS_4 : STAT_MAX_AT_LEVEL_INIT_WIS;

        if (STAT_MAX_AT_LEVEL_INIT_STR <= str) section.activatePlusBtn('STR', false);
        if (STAT_MAX_AT_LEVEL_INIT_DEX <= dex) section.activatePlusBtn('DEX', false);
        if (STAT_MAX_AT_LEVEL_INIT_INT <= int) section.activatePlusBtn('INT', false);
        if (STAT_MAX_AT_LEVEL_INIT_CON <= con) section.activatePlusBtn('CON', false);
        if (STAT_MAX_AT_LEVEL_INIT_WIS <= wis) section.activatePlusBtn('WIS', false);
        if (STAT_MAX_AT_LEVEL_INIT_CHA <= cha) section.activatePlusBtn('CHA', false);
      }

      // if level < 90, stat max value is 45.
      // if level >= 90, stat max value is 50.
      /* if (_.statData.level < _.model.LEVEL_CHANGE_STAT_MAX) {
        if (_.model.STAT_MAX <= str) section.activatePlusBtn('STR', false);
        if (_.model.STAT_MAX <= dex) section.activatePlusBtn('DEX', false);
        if (_.model.STAT_MAX <= int) section.activatePlusBtn('INT', false);
        if (_.model.STAT_MAX <= con) section.activatePlusBtn('CON', false);
        if (_.model.STAT_MAX <= wis) section.activatePlusBtn('WIS', false);
        if (_.model.STAT_MAX <= cha) section.activatePlusBtn('CHA', false);
        } else {
        if (_.model.CHANGED_STAT_MAX <= str) section.activatePlusBtn('STR', false);
        if (_.model.CHANGED_STAT_MAX <= dex) section.activatePlusBtn('DEX', false);
        if (_.model.CHANGED_STAT_MAX <= int) section.activatePlusBtn('INT', false);
        if (_.model.CHANGED_STAT_MAX <= con) section.activatePlusBtn('CON', false);
        if (_.model.CHANGED_STAT_MAX <= wis) section.activatePlusBtn('WIS', false);
        if (_.model.CHANGED_STAT_MAX <= cha) section.activatePlusBtn('CHA', false);
      }*/
      // 2021.12
      // 2022.01 .level-> .targetLevel
      var _getStatMax = Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["h" /* getStatMaxByLevel */])(parseInt(_.statData.targetLevel), _.model.STAT_MAX_BY_LEVEL);

      if (_getStatMax <= str) section.activatePlusBtn('STR', false);
      if (_getStatMax <= dex) section.activatePlusBtn('DEX', false);
      if (_getStatMax <= int) section.activatePlusBtn('INT', false);
      if (_getStatMax <= con) section.activatePlusBtn('CON', false);
      if (_getStatMax <= wis) section.activatePlusBtn('WIS', false);
      if (_getStatMax <= cha) section.activatePlusBtn('CHA', false);

      if (_.statData.level >= _.statData.targetLevel) header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE); // 2022.01 targetLevel

    }
  }, {
    key: 'setLevelUpKeyEvents',
    value: function setLevelUpKeyEvents(deviceType) {
      var _ = this;

      if (deviceType === 'pc') {
        $(document).off('keyup.levelup', '.simulator__stat').on('keyup.levelup', '.simulator__stat', function (evt) {
          if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["b" /* anyOf */])(evt.keyCode === 86, evt.which === 86)) $(_.header).trigger({ type: __WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */].EVT_LEVEL_UP });
        });
      }
    }
  }, {
    key: 'focusWrap',
    value: function focusWrap(deviceType) {
      var _ = this;

      switch (deviceType) {
        case 'pc':
          $('.simulator__stat', _.wrap).focus();
          break;
      }
    }
  }, {
    key: 'isEmptyRemainStat',
    value: function isEmptyRemainStat() {
      var _ = this;

      if (_.statData.remainStat > 0) {
        _.global.alert(__WEBPACK_IMPORTED_MODULE_7__model_msg_stat__["a" /* ALERT */].REQUIRE_EXHAUST_STAT); // '남은 스탯 포인트를 모두 배분해주세요.'

        return false;
      }

      return true;
    }
  }, {
    key: 'destroyContents',
    value: function destroyContents() {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(_.topBar)) {
        _.setTopBarEvents(false);

        _.topBar.destroy();
        _.topBar = null;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(_.header)) {
        _.setHeaderEvents(false);

        _.header.destroy();
        _.header = null;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(_.section)) {
        _.setSectionEvents(false);

        _.section.destroy();
        _.section = null;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ = this;

      _.destroyContents();

      _.wrap.empty();
    }

    /*
     * by setting qna board
     */

  }, {
    key: 'removeTopBar',
    value: function removeTopBar() {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_10__utils_util__["j" /* isDefined */])(_.topBar)) {
        _.setTopBarEvents(false);

        _.topBar.destroy();
        _.topBar = null;
      }

      $('.simulator__stat > header', _.wrap).remove();
    }
  }]);

  return StatSimulator;
}();

StatSimulator.EVT_CLOSE = 'EVT_CLOSE';
StatSimulator.EVT_SAVE_STAT_COMPLETE = 'EVT_SAVE_STAT_COMPLETE';
StatSimulator.EVT_DELETE_STAT_COMPLETE = 'EVT_DELETE_STAT_COMPLETE';

/* harmony default export */ __webpack_exports__["a"] = (StatSimulator);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_msg_stat__ = __webpack_require__(34);





var TopBar = function () {
  function TopBar(options) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TopBar);

    var _ = this;

    _.option = $.extend({
      page: 'default', // default, modify, view
      wrap: null,
      global: window
    }, options);

    _.wrap = null;

    _.global = _.option.global;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TopBar, [{
    key: 'init',
    value: function init() {
      var _ = this;

      _.wrap = $(_.option.wrap);

      _.setInstance();

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance() {
      var _ = this;

      _.setBtns();
    }
  }, {
    key: 'setBtns',
    value: function setBtns() {
      var _ = this,
          $_ = $(_);

      $('.icon-back', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: TopBar.EVT_CLOSE });
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["b" /* anyOf */])(_.option.page === 'default', _.option.page === 'modify')) {
        $('.util .btn-save', _.wrap).on('click', function (evt) {
          evt.preventDefault();
          $_.trigger({ type: TopBar.EVT_SAVE });
        });

        $('.util .btn-reset', _.wrap).on('click', function (evt) {
          evt.preventDefault();
          $_.trigger({ type: TopBar.EVT_TRY_RESET });

          var isResetConfirm = _.global.confirm(__WEBPACK_IMPORTED_MODULE_3__model_msg_stat__["a" /* ALERT */].CONFIRM_RESET);
          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(isResetConfirm)) $_.trigger({ type: TopBar.EVT_RESET });
        });
      } else if (_.option.page === 'view') {
        $('.util .btn-modify', _.wrap).on('click', function (evt) {
          evt.preventDefault();
          $_.trigger({ type: TopBar.EVT_MODIFY });
        });

        $('.util .btn-delete', _.wrap).on('click', function (evt) {
          evt.preventDefault();
          $_.trigger({ type: TopBar.EVT_DELETE });
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ = this;

      $('.icon-back', _.wrap).off('click');

      $('.util .btn-save', _.wrap).off('click');
      $('.util .btn-reset', _.wrap).off('click');

      $('.util .btn-modify', _.wrap).off('click');
      $('.util .btn-delete', _.wrap).off('click');
    }
  }]);

  return TopBar;
}();

TopBar.EVT_CLOSE = 'EVT_CLOSE';
TopBar.EVT_SAVE = 'EVT_SAVE';
TopBar.EVT_TRY_RESET = 'EVT_TRY_RESET';
TopBar.EVT_RESET = 'EVT_RESET';
TopBar.EVT_MODIFY = 'EVT_MODIFY';
TopBar.EVT_DELETE = 'EVT_DELETE';

/* harmony default export */ __webpack_exports__["a"] = (TopBar);

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
module.exports = __webpack_require__(2).Number.isInteger;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', { isInteger: __webpack_require__(101) });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(8);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatModel__ = __webpack_require__(23);





var Header = function () {
  function Header(options) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Header);

    var _ = this;

    _.option = $.extend({
      wrap: null,
      data: null,
      model: null,
      global: window
    }, options);

    _.data = _.option.data;

    _.model = __WEBPACK_IMPORTED_MODULE_3__StatModel__["a" /* default */].getInstance();

    _.wrap = null;

    _.levelField = null;

    _.remainStatField = null;

    _.remainTotalStatField = null;

    _.elixirStatField = null;

    _.elixirTotalStatField = null;

    _.elixirStatCheckBox = null;

    _.levelUpBtn = null;

    _.tooltipIntroduceShortcut = null;

    _.isShowedTooltipIntroduceShortcut = false;

    _.global = _.option.global;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Header, [{
    key: 'init',
    value: function init() {
      var _ = this;

      _.wrap = $(_.option.wrap);

      _.levelField = $('.level > strong', _.wrap);

      _.remainStatField = $('.point p:first .em', _.wrap);

      _.remainTotalStatField = $('.point p:first .total', _.wrap);

      _.elixirStatField = $('.point .elixir var strong', _.wrap);

      _.elixirTotalStatField = $('.point .elixir .total', _.wrap);

      _.elixirStatCheckBox = $('#ELIXIR_POINT', _.wrap);

      _.levelUpBtn = $('.btn-levelup', _.wrap);

      _.tooltipIntroduceShortcut = $('.tooltip-levelup', _.wrap);

      _.setInstance();

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance() {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["j" /* isDefined */])(_.data)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["j" /* isDefined */])(_.data.level)) _.setLevel(_.data.level);

        Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["a" /* allOf */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["i" /* isBoolean */])(_.data.elixirUseYN), Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(_.data.elixirUseYN)) ? _.setElixirStatCheckBoxChecked(true) : _.setElixirStatCheckBoxChecked(false);

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["s" /* parseInt10 */])(_.data.remainStat) > 0, Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["s" /* parseInt10 */])(_.data.remainTotalStat) <= 0)) _.setLevelUpBtnUsable(false);

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["s" /* parseInt10 */])(_.data.level) >= Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["s" /* parseInt10 */])(_.data.targetLevel)) {
          _.setLevelUpBtnUsable(false);
        }
      }

      _.setBtns();

      _.setElixirStatCheckBoxEvent();

      if (_.model.DEVICE_TYPE === 'mobile') {
        // phone or tablet
        _.showTooltipOnlyOnce(false);
      }
    }
  }, {
    key: 'showTooltipOnlyOnce',
    value: function showTooltipOnlyOnce(flag) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(flag)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(_.isShowedTooltipIntroduceShortcut)) return;
        _.isShowedTooltipIntroduceShortcut = true;

        _.tooltipIntroduceShortcut.show();
      } else {
        _.tooltipIntroduceShortcut.hide();
      }
    }
  }, {
    key: 'setBtns',
    value: function setBtns() {
      var _ = this,
          $_ = $(_);

      _.levelUpBtn.on('click', function (evt) {
        evt.preventDefault();

        $_.trigger({ type: Header.EVT_LEVEL_UP });
      });
    }
  }, {
    key: 'setElixirStatCheckBoxEvent',
    value: function setElixirStatCheckBoxEvent() {
      var _ = this,
          $_ = $(_);

      _.elixirStatCheckBox.on('change', function (evt) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(_.isCheckedElixirStatCheckBox()) ? _.setElixirStatCheckBoxChecked(true) : _.setElixirStatCheckBoxChecked(false);

        $_.trigger({ type: Header.EVT_CHECK_ELIXIR_CHECKBOX });
      });
    }
  }, {
    key: 'setLevel',
    value: function setLevel(level) {
      this.levelField.text(level);
    }
  }, {
    key: 'setHpMp',
    value: function setHpMp(stats) {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["j" /* isDefined */])(stats.HP)) {
        var hp = Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["t" /* parseStrIntToInt */])(stats.HP) <= 0 ? '-' : stats.HP;
        $('.hp var', _.wrap).text(hp);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["j" /* isDefined */])(stats.MP)) {
        var mp = Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["t" /* parseStrIntToInt */])(stats.MP) <= 0 ? '-' : stats.MP;
        $('.mp var', _.wrap).text(mp);
      }
    }
  }, {
    key: 'setRemainStat',
    value: function setRemainStat(point) {
      this.remainStatField.text(point);
    }
  }, {
    key: 'setRemainTotalStat',
    value: function setRemainTotalStat(point) {
      this.remainTotalStatField.text('(' + point + ')');
    }
  }, {
    key: 'setElixirStat',
    value: function setElixirStat(point) {
      this.elixirStatField.text(point);
    }
  }, {
    key: 'setElixirTotalStat',
    value: function setElixirTotalStat(point) {
      this.elixirTotalStatField.text('(' + point + ')');
    }
  }, {
    key: 'setAllStats',
    value: function setAllStats() {
      var statData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ = this;

      _.setRemainStat(statData.remainStat);
      _.setRemainTotalStat(statData.remainTotalStat);
      _.setElixirStat(statData.elixirStat);
      _.setElixirTotalStat(statData.elixirTotalStat);
    }
  }, {
    key: 'activateElixirStatField',
    value: function activateElixirStatField(flag) {
      var _ = this;

      if (_.elixirStatField.length <= 0) return;

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(flag) ? _.elixirStatField.addClass('on') : _.elixirStatField.removeClass('on');
    }
  }, {
    key: 'setElixirStatCheckBoxChecked',
    value: function setElixirStatCheckBoxChecked(flag) {
      var _ = this,
          customCheckBox = $('.custom-checkbox', _.wrap);

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(flag)) {
        _.elixirStatCheckBox.prop('checked', true);
        customCheckBox.addClass('selected');
      } else {
        _.elixirStatCheckBox.prop('checked', false);
        customCheckBox.removeClass('selected');
      }
    }
  }, {
    key: 'setLevelUpBtnUsable',
    value: function setLevelUpBtnUsable(flag, deviceType) {
      var _ = this;

      if (_.levelUpBtn.length <= 0) return;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(flag)) {
        _.levelUpBtn.attr('disabled', false).addClass('on');
      } else {
        _.levelUpBtn.attr('disabled', true).removeClass('on');
      }

      if (deviceType === 'pc') {
        _.showTooltipOnlyOnce(flag);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      var statData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["j" /* isDefined */])(statData.level)) _.setLevel(statData.level);

      Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["u" /* truthy */])(statData.elixirUseYN) ? _.setElixirStatCheckBoxChecked(true) : _.setElixirStatCheckBoxChecked(false);

      _.setAllStats(statData);
    }
  }, {
    key: 'isCheckedElixirStatCheckBox',
    value: function isCheckedElixirStatCheckBox() {
      return this.elixirStatCheckBox.prop('checked');
    }
  }, {
    key: 'isUsableLevelUpBtn',
    value: function isUsableLevelUpBtn() {
      return !this.levelUpBtn.prop('disabled');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ = this;

      _.levelUpBtn.off('click');

      _.elixirStatCheckBox.off('change');
    }
  }]);

  return Header;
}();

Header.EVT_LEVEL_UP = 'EVT_LEVEL_UP';
Header.EVT_CHECK_ELIXIR_CHECKBOX = 'EVT_CHECK_ELIXIR_CHECKBOX';

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(104);
__webpack_require__(39);
__webpack_require__(110);
__webpack_require__(111);
module.exports = __webpack_require__(2).Symbol;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(0);
var has = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(5);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(42);
var META = __webpack_require__(105).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(30);
var setToStringTag = __webpack_require__(22);
var uid = __webpack_require__(21);
var wks = __webpack_require__(1);
var wksExt = __webpack_require__(53);
var wksDefine = __webpack_require__(35);
var enumKeys = __webpack_require__(106);
var isArray = __webpack_require__(107);
var anObject = __webpack_require__(4);
var toIObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(20);
var _create = __webpack_require__(43);
var gOPNExt = __webpack_require__(108);
var $GOPD = __webpack_require__(109);
var $DP = __webpack_require__(3);
var $keys = __webpack_require__(28);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(55).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(36).f = $propertyIsEnumerable;
  __webpack_require__(54).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(16)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(7)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(21)('meta');
var isObject = __webpack_require__(8);
var has = __webpack_require__(9);
var setDesc = __webpack_require__(3).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(28);
var gOPS = __webpack_require__(54);
var pIE = __webpack_require__(36);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(15);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(13);
var gOPN = __webpack_require__(55).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(36);
var createDesc = __webpack_require__(20);
var toIObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(41);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35)('asyncIterator');


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35)('observable');


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_tpl_stat__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatModel__ = __webpack_require__(23);






var Section = function () {
  function Section(options) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    var _ = this;

    _.option = $.extend({
      wrap: null,
      model: null
    }, options);

    _.wrap = null;

    _.model = __WEBPACK_IMPORTED_MODULE_4__StatModel__["a" /* default */].getInstance();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'init',
    value: function init() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ = this;

      _.wrap = $(_.option.wrap);

      _.setInstance();

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance() {
      var _ = this;

      _.setUpDownBtns();

      _.activateAllMinusBtns(false);

      _.activateAllPlusBtns(false);
    }
  }, {
    key: 'setUpDownBtns',
    value: function setUpDownBtns() {
      var _ = this,
          $_ = $(this);

      // plus btns
      $('.stat-STR button.up', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_PLUS_STAT, statName: 'STR' });
      });

      $('.stat-DEX button.up', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_PLUS_STAT, statName: 'DEX' });
      });

      $('.stat-INT button.up', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_PLUS_STAT, statName: 'INT' });
      });

      $('.stat-CON button.up', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_PLUS_STAT, statName: 'CON' });
      });

      $('.stat-WIS button.up', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_PLUS_STAT, statName: 'WIS' });
      });

      $('.stat-CHA button.up', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_PLUS_STAT, statName: 'CHA' });
      });

      // minus btns
      $('.stat-STR button.down', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_MINUS_STAT, statName: 'STR' });
      });

      $('.stat-DEX button.down', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_MINUS_STAT, statName: 'DEX' });
      });

      $('.stat-INT button.down', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_MINUS_STAT, statName: 'INT' });
      });

      $('.stat-CON button.down', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_MINUS_STAT, statName: 'CON' });
      });

      $('.stat-WIS button.down', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_MINUS_STAT, statName: 'WIS' });
      });

      $('.stat-CHA button.down', _.wrap).on('click', function (evt) {
        evt.preventDefault();
        $_.trigger({ type: Section.EVT_MINUS_STAT, statName: 'CHA' });
      });
    }
  }, {
    key: 'removeUpDownBtnsEventHandler',
    value: function removeUpDownBtnsEventHandler() {
      var _ = this;

      $('.stat-STR button', _.wrap).off('click');
      $('.stat-DEX button', _.wrap).off('click');
      $('.stat-INT button', _.wrap).off('click');
      $('.stat-CON button', _.wrap).off('click');
      $('.stat-WIS button', _.wrap).off('click');
      $('.stat-CHA button', _.wrap).off('click');
    }
  }, {
    key: 'setBtnUsable',
    value: function setBtnUsable($btn, flag) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["q" /* not */])(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])($btn), $btn.length < 0)) return;

      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["u" /* truthy */])(flag)) {
        $btn.attr('disabled', false).addClass('on');
      } else {
        $btn.attr('disabled', true).removeClass('on');
      }
    }
  }, {
    key: 'activateAllMinusBtns',
    value: function activateAllMinusBtns(flag) {
      var _ = this,
          downBtns = $('button.down', _.wrap);

      for (var i = 0, max = downBtns.length; i < max; i++) {
        _.setBtnUsable($(downBtns.get(i)), flag);
      }
    }
  }, {
    key: 'activateAllPlusBtns',
    value: function activateAllPlusBtns(flag) {
      var _ = this,
          upBtns = $('button.up', _.wrap);

      for (var i = 0, max = upBtns.length; i < max; i++) {
        _.setBtnUsable($(upBtns.get(i)), flag);
      }
    }
  }, {
    key: 'activatePlusBtn',
    value: function activatePlusBtn(statName, flag) {
      var _ = this,
          btn = $('.' + statName + ' button.up', _.wrap);

      _.setBtnUsable(btn, flag);
    }
  }, {
    key: 'activateMinusBtn',
    value: function activateMinusBtn(statName, flag) {
      var _ = this,
          btn = $('.' + statName + ' button.down', _.wrap);

      _.setBtnUsable(btn, flag);
    }
  }, {
    key: 'setChangedStat',
    value: function setChangedStat(isCompleteSetBaseStat, changedStats, receivedStats, statsFirstAtLevel) {
      var baseStatsForHighlight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var _ = this;

      console.log('changedStats :', changedStats);

      //set stats
      for (var key in changedStats) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["q" /* not */])(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedStats[key])) continue;

        var statList = $('.' + key, _.wrap);
        if (statList.length > 0) {

          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["u" /* truthy */])(isCompleteSetBaseStat)) {
            key === 'STR' || key === 'INT' || key === 'DEX' || key === 'WIS' || key === 'CON' || key === 'CHA' ? statList.addClass('on') : statList.addClass('em1').addClass('em2');
          } else {
            key === 'STR' || key === 'INT' || key === 'DEX' || key === 'WIS' || key === 'CON' || key === 'CHA' ? statList.addClass('on') : statList.addClass('em1');
          }

          $('.' + key + ' var', _.wrap).text(changedStats[key]);
        }
      }

      _.setChangedRangeField(isCompleteSetBaseStat, $('.LEVELUP_MP_PLUS', _.wrap), changedStats.LEVELUP_MP_PLUS_MIN, changedStats.LEVELUP_MP_PLUS_MAX, receivedStats.LEVELUP_MP_PLUS_MIN, receivedStats.LEVELUP_MP_PLUS_MAX);
      _.setChangedRangeField(isCompleteSetBaseStat, $('.HP_PLUS', _.wrap), changedStats.LEVELUP_HP_PLUS_MIN, changedStats.LEVELUP_HP_PLUS_MAX, receivedStats.LEVELUP_HP_PLUS_MIN, receivedStats.LEVELUP_HP_PLUS_MAX);
      _.setChangedRangeField(isCompleteSetBaseStat, $('.HP_RECOVER_TIC', _.wrap), changedStats.HP_RECOVER_TIC_MIN, changedStats.HP_RECOVER_TIC_MAX, receivedStats.HP_RECOVER_TIC_MIN, receivedStats.HP_RECOVER_TIC_MAX);

      // minus
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(statsFirstAtLevel)) {
        console.log('statsFirstAtLevel :', statsFirstAtLevel);

        var changedVal = void 0,
            statItem = void 0;
        for (var _key in changedStats) {
          changedVal = changedStats[_key];

          statItem = $('.' + _key, _.wrap);

          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["q" /* not */])(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedVal), statItem.length <= 0)) continue;

          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["u" /* truthy */])(isCompleteSetBaseStat)) {
            if (changedVal === statsFirstAtLevel[_key]) statItem.removeClass('em2');

            if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(baseStatsForHighlight)) {
              if (changedVal === baseStatsForHighlight[_key]) statItem.removeClass('on').removeClass('em1');
            }
          } else {
            if (changedVal === statsFirstAtLevel[_key]) statItem.removeClass('on').removeClass('em1');
          }
        }

        // WIS
        _.setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, $('.LEVELUP_MP_PLUS', _.wrap), 'LEVELUP_MP_PLUS_MIN', 'LEVELUP_MP_PLUS_MAX', changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight);

        // CON
        _.setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, $('.HP_PLUS', _.wrap), 'LEVELUP_HP_PLUS_MIN', 'LEVELUP_HP_PLUS_MAX', changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight);
        _.setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, $('.HP_RECOVER_TIC', _.wrap), 'HP_RECOVER_TIC_MIN', 'HP_RECOVER_TIC_MAX', changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight);
      }
    }
  }, {
    key: 'setChangedRangeFieldCompareStatFirstAtLevel',
    value: function setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, statItem, minValueName, maxValueName, changedStats, receivedStats, statsFirstAtLevel) {
      var baseStatsForHighlight = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedStats[minValueName]), Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedStats[maxValueName]))) {
        var minVal = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(receivedStats[minValueName]),
            maxVal = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(receivedStats[maxValueName]);

        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["u" /* truthy */])(isCompleteSetBaseStat)) {
          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["a" /* allOf */])(minVal === Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(statsFirstAtLevel[minValueName]), maxVal === Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(statsFirstAtLevel[maxValueName]))) statItem.removeClass('em2');

          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(baseStatsForHighlight)) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["a" /* allOf */])(minVal === Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(baseStatsForHighlight[minValueName]), maxVal === Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(baseStatsForHighlight[maxValueName]))) statItem.removeClass('em1');
          }
        } else {
          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["a" /* allOf */])(minVal === Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(statsFirstAtLevel[minValueName]), maxVal === Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["t" /* parseStrIntToInt */])(statsFirstAtLevel[maxValueName]))) statItem.removeClass('em1');
        }
      }
    }
  }, {
    key: 'setChangedRangeField',
    value: function setChangedRangeField(isCompleteSetBaseStat, statItem, changedMin, changedMax, receiveMin, receiveMax) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedMin), Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedMax))) {
        if (statItem.length <= 0) return;

        Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["u" /* truthy */])(isCompleteSetBaseStat) ? statItem.addClass('em1').addClass('em2') : statItem.addClass('em1');

        $('var', statItem).text(receiveMin + ' ~ ' + receiveMax);
      }
    }
  }, {
    key: 'setStatValueColor',
    value: function setStatValueColor(level) {
      var _ = this,
          stats = [$('.STR', _.wrap), $('.INT', _.wrap), $('.DEX', _.wrap), $('.WIS', _.wrap), $('.CON', _.wrap), $('.CHA', _.wrap)];

      // stat max value is 45, when level < 90
      // stat max value is 50, when level >= 90
      var statLevelColors = level < _.model.LEVEL_CHANGE_STAT_MAX ? _.model.STAT_LEVEL_COLORS : _.model.CHANGED_LEVEL_COLORS;

      var stat = null,
          point = 0;

      var _loop = function _loop(i, max) {
        stat = stats[i];
        point = Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["s" /* parseInt10 */])($('var', stat).text());

        Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["c" /* each */])(statLevelColors, function (colorObj) {
          stat.removeClass(colorObj.class);
        });

        var colorClass = '';
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["c" /* each */])(statLevelColors, function (colorObj) {
          if (colorObj.level <= point) {
            if (colorClass !== '') stat.removeClass(colorClass);

            colorClass = colorObj.class;
            stat.addClass(colorClass);
          }
        });
      };

      for (var i = 0, max = stats.length; i < max; i++) {
        _loop(i, max);
      }
    }

    // add '.on' class to changed stats

  }, {
    key: 'setHighlightChangedStats',
    value: function setHighlightChangedStats(changedStats) {
      var _ = this;

      //set stats
      var statItem = null;
      for (var key in changedStats) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["q" /* not */])(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedStats[key])) continue;

        statItem = $('.' + key, _.wrap);
        key === 'STR' || key === 'INT' || key === 'DEX' || key === 'WIS' || key === 'CON' || key === 'CHA' ? statItem.addClass('on') : statItem.addClass('em1');
      }

      _.setHighlightRangedField($('.HP_PLUS', _.wrap), changedStats.LEVELUP_HP_PLUS_MIN, changedStats.LEVELUP_HP_PLUS_MAX);
      _.setHighlightRangedField($('.HP_RECOVER_TIC', _.wrap), changedStats.HP_RECOVER_TIC_MIN, changedStats.HP_RECOVER_TIC_MAX);
      _.setHighlightRangedField($('.LEVELUP_MP_PLUS', _.wrap), changedStats.LEVELUP_MP_PLUS_MIN, changedStats.LEVELUP_MP_PLUS_MAX);
    }
  }, {
    key: 'setHighlightRangedField',
    value: function setHighlightRangedField(statList, changedMinVal, changedMaxVal) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["b" /* anyOf */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedMinVal), Object(__WEBPACK_IMPORTED_MODULE_3__utils_util__["j" /* isDefined */])(changedMaxVal))) {
        if (statList.length > 0) statList.addClass('em1');
      }
    }
  }, {
    key: 'reset',
    value: function reset(stats) {
      var _ = this;

      _.removeUpDownBtnsEventHandler();

      var sectionTplFunc = doT.template(Object(__WEBPACK_IMPORTED_MODULE_2__model_tpl_stat__["b" /* getSectionTpl */])());
      _.wrap.replaceWith(sectionTplFunc(stats));
      _.wrap = $('.variation.variation__stat');

      _.setUpDownBtns();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _ = this;

      _.removeUpDownBtnsEventHandler();
    }
  }]);

  return Section;
}();

Section.EVT_PLUS_STAT = 'EVT_PLUS_STAT';
Section.EVT_MINUS_STAT = 'EVT_MINUS_STAT';

/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(2);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};



/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year())) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117)(module)))

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Laura Doktorova https://github.com/olado/doT */
!function () {
  "use strict";
  function e(n, t, r) {
    return ("string" == typeof t ? t : t.toString()).replace(n.define || a, function (e, t, o, a) {
      return 0 === t.indexOf("def.") && (t = t.substring(4)), t in r || (":" === o ? (n.defineParams && a.replace(n.defineParams, function (e, n, o) {
        r[t] = { arg: n, text: o };
      }), t in r || (r[t] = a)) : new Function("def", "def['" + t + "']=" + a)(r)), "";
    }).replace(n.use || a, function (t, o) {
      n.useParams && (o = o.replace(n.useParams, function (e, n, t, o) {
        if (r[t] && r[t].arg && o) {
          var a = (t + ":" + o).replace(/'|\\/g, "_");return r.__exp = r.__exp || {}, r.__exp[a] = r[t].text.replace(new RegExp("(^|[^\\w$])" + r[t].arg + "([^\\w$])", "g"), "$1" + o + "$2"), n + "def.__exp['" + a + "']";
        }
      }));var a = new Function("def", "return " + o)(r);return a ? e(n, a, r) : a;
    });
  }function n(e) {
    return e.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
  }var t,
      r = { engine: "doT", version: "1.1.1", templateSettings: { evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g, interpolate: /\{\{=([\s\S]+?)\}\}/g, encode: /\{\{!([\s\S]+?)\}\}/g, use: /\{\{#([\s\S]+?)\}\}/g, useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g, define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g, defineParams: /^\s*([\w$]+):([\s\S]+)/, conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g, iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g, varname: "it", strip: !0, append: !0, selfcontained: !1, doNotSkipEncoded: !1 }, template: void 0, compile: void 0, log: !0 };r.encodeHTMLSource = function (e) {
    var n = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
        t = e ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;return function (e) {
      return e ? e.toString().replace(t, function (e) {
        return n[e] || e;
      }) : "";
    };
  }, t = function () {
    return this || (0, eval)("this");
  }(), "undefined" != typeof module && module.exports ? module.exports = r :  true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return r;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : t.doT = r;var o = { append: { start: "'+(", end: ")+'", startencode: "'+encodeHTML(" }, split: { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" } },
      a = /$^/;r.template = function (c, i, u) {
    i = i || r.templateSettings;var d,
        s,
        p = i.append ? o.append : o.split,
        l = 0,
        f = i.use || i.define ? e(i, c, u || {}) : c;f = ("var out='" + (i.strip ? f.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") : f).replace(/'|\\/g, "\\$&").replace(i.interpolate || a, function (e, t) {
      return p.start + n(t) + p.end;
    }).replace(i.encode || a, function (e, t) {
      return d = !0, p.startencode + n(t) + p.end;
    }).replace(i.conditional || a, function (e, t, r) {
      return t ? r ? "';}else if(" + n(r) + "){out+='" : "';}else{out+='" : r ? "';if(" + n(r) + "){out+='" : "';}out+='";
    }).replace(i.iterate || a, function (e, t, r, o) {
      return t ? (l += 1, s = o || "i" + l, t = n(t), "';var arr" + l + "=" + t + ";if(arr" + l + "){var " + r + "," + s + "=-1,l" + l + "=arr" + l + ".length-1;while(" + s + "<l" + l + "){" + r + "=arr" + l + "[" + s + "+=1];out+='") : "';} } out+='";
    }).replace(i.evaluate || a, function (e, t) {
      return "';" + n(t) + "out+='";
    }) + "';return out;").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r").replace(/(\s|;|\}|^|\{)out\+='';/g, "$1").replace(/\+''/g, ""), d && (i.selfcontained || !t || t._encodeHTML || (t._encodeHTML = r.encodeHTMLSource(i.doNotSkipEncoded)), f = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (" + r.encodeHTMLSource.toString() + "(" + (i.doNotSkipEncoded || "") + "));" + f);try {
      return new Function(i.varname, f);
    } catch (e) {
      throw "undefined" != typeof console && console.log("Could not create a template function: " + f), e;
    }
  }, r.compile = function (e, n) {
    return r.template(e, null, n);
  };
}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// world/stat-setting.js